var _defs, _path, _path2, _polygon, _path3, _polygon2, _rect, _path4, _path5, _polygon3, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _polygon4, _polygon5, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _ellipse, _ellipse2, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _polygon6, _polygon7, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _ellipse3, _path140, _path141, _path142, _path143, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _circle, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _ellipse12, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _ellipse13, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _ellipse14, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _ellipse15, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _ellipse16, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _path256, _path257, _path258, _path259, _polygon8, _polygon9, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _path283, _path284, _path285, _path286, _path287, _path288, _polygon18, _polygon19, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _rect2, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebFigureMotiv3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 496.25 334.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_8",
    x1: -262.7,
    y1: 200.46,
    x2: -151.11,
    y2: 200.46,
    gradientTransform: "translate(264.34)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#616262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#969697"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#9c9c9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8e7e7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_7",
    x1: -262.7,
    y1: 198.53,
    x2: -151.14,
    y2: 198.53,
    gradientTransform: "translate(264.34)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#272626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#272626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#292828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#393939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#3f3f3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#595a5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#595a5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#686969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_441",
    x1: 70.86,
    y1: 127.54,
    x2: 129.54,
    y2: 127.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#272626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#2a292b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#383739"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_441-2",
    x1: 70.86,
    y1: 118.91,
    x2: 129.54,
    y2: 118.91,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_441"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_441-3",
    x1: 70.86,
    y1: 79.2,
    x2: 129.54,
    y2: 79.2,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_441"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_866",
    x1: 161.1,
    y1: 158.59,
    x2: 161.1,
    y2: 205.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#90191c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#e03626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#ee2f24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_800",
    x1: 146.7,
    y1: 162.74,
    x2: 193.29,
    y2: 162.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b8a8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8d8c8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#949190"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#9f9b98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#9f9b98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#a19d9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#b1adab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#bcb9b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#c2bfbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#c4c1bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#dcdbd9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#dcdbd9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#d8d9d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#d7d7d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#d1d1cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8c5c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c4c1bf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_796",
    x1: 146.43,
    y1: 159.5,
    x2: 192.97,
    y2: 159.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aeaeae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#b0afaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#b7b5b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#c2beba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#c2beba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#c5c1bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#d4d1ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#dedcd9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#e4e2e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#e6e4e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#fffffd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#fffffd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#fbfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f9fafa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f4f4f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebe9e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e4e2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_731",
    x1: 158.55,
    y1: 164.46,
    x2: 156.17,
    y2: 168.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#ededee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#e9e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#d0d1d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#cacaca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#c2c1c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#b1b0b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#a3a3a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9e9e9e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_731-2",
    x1: 158.21,
    y1: 164.65,
    x2: 155.66,
    y2: 169.08,
    xlinkHref: "#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_731"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_865",
    x1: 184.15,
    y1: 203.27,
    x2: 168.59,
    y2: 176.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c72026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#ef3e23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#ee3724"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M288.94,163.33c3.32,120,46.76,120,104.43,120s107.08-14.64,104.43-120c-2.43-96.88-27.32-124-104.43-120C332.55,46.4,286,56.52,288.94,163.33Z",
    transform: "translate(-1.65)",
    fill: "#ccc9c6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.15,34.53V26c0-4.69,5.4-8.53,12-8.53H381.36c6.6,0,12,4.66,12,10.36V31",
    transform: "translate(-1.65)",
    fill: "none",
    stroke: "#ef5182",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    strokeDasharray: "6 3"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "386.72 29.55 391.71 38.19 396.69 29.55 386.72 29.55",
    fill: "#ef5182"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M395.7,292.27V305.1a12,12,0,0,1-12,12H115.48a12,12,0,0,1-12-12v-11",
    transform: "translate(-1.65)",
    fill: "none",
    stroke: "#ef5182",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    strokeDasharray: "6 3"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "106.82 295.59 101.84 286.96 96.85 295.59 106.82 295.59",
    fill: "#ef5182"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 133.49,
    width: 210.04,
    height: 34.93,
    fill: "#ef5182"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M113.2,211.21h0v-5.13l-5,.35-1.73-.32L43.07,169.47c-2.56-1.48-6.48-1.64-8.69-.36L6.77,185.05l-5.12-1v5.25h0a3.58,3.58,0,0,0,2.12,2.83l68.06,39.29c2.56,1.48,6.47,1.65,8.69.37l31.23-18A2.43,2.43,0,0,0,113.2,211.21Z",
    transform: "translate(-1.65)",
    fill: "url(#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_8)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.77,188.3l68.06,39.29c2.56,1.48,6.47,1.64,8.69.36l31.23-18a2.73,2.73,0,0,0,1.46-1.83v-.69a.13.13,0,0,1,0-.06h0v-1.26l-5,.35-1.73-.32L43.07,169.47c-2.56-1.48-6.48-1.64-8.69-.36L6.77,185.05l-5.12-1v1.38h0A3.59,3.59,0,0,0,3.77,188.3Z",
    transform: "translate(-1.65)",
    fill: "url(#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_7)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "1.91 188.25 67.39 226.06 67.39 224.53 1.91 186.72 1.91 188.25",
    fill: "#3b3c3b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.38,163.8l-31.23,18c-2.22,1.28-1.94,3.54.62,5l68.06,39.29c2.56,1.48,6.47,1.64,8.69.36l31.23-18c2.22-1.28,1.94-3.54-.63-5L43.07,164.16C40.51,162.68,36.59,162.52,34.38,163.8Z",
    transform: "translate(-1.65)",
    fill: "#5e5f5f"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.56,186.71l.21.14L69,224.53l39.3-22.69L43.07,164.16l-.23-.12Z",
    transform: "translate(-1.65)",
    fill: "#3b3c3b"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92,180.54a2.29,2.29,0,0,0,2.07,0,.63.63,0,0,0,0-1.2,2.26,2.26,0,0,0-2.07,0C9.35,179.68,9.35,180.21,9.92,180.54Z",
    transform: "translate(-1.65)",
    fill: "#3b3c3b"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.53,178.63a1.58,1.58,0,0,0,1.42,0,.43.43,0,0,0,0-.82,1.61,1.61,0,0,0-1.42,0A.44.44,0,0,0,13.53,178.63Z",
    transform: "translate(-1.65)",
    fill: "#753c3c"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.56,218.08l7.33-4.23c.91-.52.8-1.44-.25-2h0a4,4,0,0,0-3.56-.15l-7.32,4.23c-.92.53-.8,1.45.25,2.06h0A4,4,0,0,0,90.56,218.08Z",
    transform: "translate(-1.65)",
    fill: "#4b4b4b"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M86.76,216.83l7.32-4.23a4,4,0,0,1,3.56.14,1.94,1.94,0,0,1,.73.68c.33-.51.07-1.16-.73-1.62a4,4,0,0,0-3.56-.15l-7.32,4.23a1,1,0,0,0-.48,1.38A1.27,1.27,0,0,1,86.76,216.83Z",
    transform: "translate(-1.65)",
    fill: "#141414"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M98.78,218.73a1.62,1.62,0,0,1-.19.73,1.31,1.31,0,0,1-.46.52l-3.79,2.19c-.36.21-.66,0-.66-.5,0-.06,0-.11,0-.17a2.29,2.29,0,0,1,.18-.56,1.33,1.33,0,0,1,.47-.52l3.55-2,.24-.14C98.49,218,98.78,218.24,98.78,218.73Z",
    transform: "translate(-1.65)",
    fill: "#868686"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M97.89,218.37a1.93,1.93,0,0,1-.18.56,1.32,1.32,0,0,1-.47.52l-3.55,2.05a2.29,2.29,0,0,1,.18-.56,1.33,1.33,0,0,1,.47-.52Z",
    transform: "translate(-1.65)",
    fill: "#3b3c3b"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "2.55 187.09 66.75 224.16 106.04 201.47 41.84 164.4 2.55 187.09",
    fill: "#262525"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "2.55 187.09 22.32 175.68 87.25 212.31 66.75 224.16 2.55 187.09",
    fill: "#383938",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "2.55 188.21 66.75 225.28 66.75 224.16 2.55 187.09 2.55 188.21",
    fill: "#272626"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18,176.46l9.21-5.31c.25-.15.21-.4-.07-.56h0a1.1,1.1,0,0,0-1-.05L17,175.86c-.24.15-.21.4.07.56h0A1.07,1.07,0,0,0,18,176.46Z",
    transform: "translate(-1.65)",
    fill: "#3b3c3b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M95.16,171.66l1.93-29.22L81.87,141h0a30.67,30.67,0,0,0-15,2C56,147,49.09,155.23,51.36,161.35c1.13,3.08,4.37,5,8.69,5.7h0Z",
    transform: "translate(-1.65)",
    fill: "#d8dad8",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M129.54,83.27,70.86,83v72.1h0c0,4.32,2.94,8.63,8.66,11.94,11.49,6.63,30.07,6.67,41.49.07,5.73-3.31,8.57-7.66,8.53-12h0Z",
    transform: "translate(-1.65)",
    fill: "url(#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_441)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M129.54,134.14l-58.68-.26V148h0c0,4.32,2.94,8.64,8.66,11.94C91,166.6,109.59,166.63,121,160c5.73-3.31,8.57-7.67,8.53-12h0Z",
    transform: "translate(-1.65)",
    fill: "#3c3c3d"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M129.54,133.63l-58.68-.25v14.14h0c0,4.32,2.94,8.63,8.66,11.94,11.49,6.63,30.07,6.67,41.49.07,5.73-3.31,8.57-7.66,8.53-12h0Z",
    transform: "translate(-1.65)",
    fill: "#151517"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M129.54,74.64l-58.68-.25v72.1h0c0,4.32,2.94,8.64,8.66,11.94,11.49,6.64,30.07,6.67,41.49.08,5.73-3.31,8.57-7.66,8.53-12h0Z",
    transform: "translate(-1.65)",
    fill: "url(#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_441-2)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M129.54,65.54l-58.68-.25V79.43h0c0,4.31,2.94,8.63,8.66,11.94C91,98,109.59,98,121,91.44c5.73-3.31,8.57-7.66,8.53-12h0Z",
    transform: "translate(-1.65)",
    fill: "#3c3c3d"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M129.54,65l-58.68-.25V78.86h0c0,4.31,2.94,8.63,8.66,11.94,11.49,6.63,30.07,6.67,41.49.07,5.73-3.31,8.57-7.66,8.53-12h0Z",
    transform: "translate(-1.65)",
    fill: "#151517"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M129.54,63.92l-58.68-.26V77.8h0c0,4.32,2.94,8.64,8.66,11.94,11.49,6.64,30.07,6.67,41.49.08,5.73-3.31,8.57-7.67,8.53-12h0Z",
    transform: "translate(-1.65)",
    fill: "url(#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_441-3)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.2,
    cy: 63.88,
    rx: 16.94,
    ry: 29.34,
    transform: "translate(34.13 163.73) rotate(-89.69)",
    fill: "#515153"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.2,
    cy: 63.88,
    rx: 16.44,
    ry: 28.48,
    transform: "translate(34.13 163.73) rotate(-89.69)",
    fill: "#5fc9dd"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M118.79,74.61c-10.2,5.9-26.8,5.87-37.07-.06S71.4,59,81.61,53.14s26.8-5.86,37.07.07S129,68.72,118.79,74.61Z",
    transform: "translate(-1.65)",
    fill: "#242426"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M117.31,72.8c-9.39,5.43-24.67,5.4-34.12-.06s-9.5-14.28-.11-19.7,24.68-5.4,34.13.06S126.71,67.38,117.31,72.8Z",
    transform: "translate(-1.65)",
    fill: "#7b7b7c"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M116.56,72.37c-9.2,5.31-24.16,5.28-33.41-.06S73.84,58.33,83,53s24.16-5.28,33.42.07S125.76,67.06,116.56,72.37Z",
    transform: "translate(-1.65)",
    fill: "#515153"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M84.46,72.31c-2.11-1.21-2.15-3.17-.08-4.37a8.42,8.42,0,0,1,7.62,0c2.12,1.22,2.14,3.17,0,4.4A8.31,8.31,0,0,1,84.46,72.31Z",
    transform: "translate(-1.65)",
    fill: "#2f2e30"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M91.13,68.8a6.73,6.73,0,0,0-6.1,0c-1.65,1-1.63,2.52.06,3.49a6.66,6.66,0,0,0,6.07,0C92.84,71.34,92.82,69.77,91.13,68.8Z",
    transform: "translate(-1.65)",
    fill: "#585859"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M89.47,69.84a4.6,4.6,0,0,0-.74-.34,6,6,0,0,0-1.62-.33,6.15,6.15,0,0,0-.86,0,.49.49,0,0,1-.32-.09.13.13,0,0,1,0-.2.36.36,0,0,1,.25-.1c.32,0,.63,0,1,0a8.6,8.6,0,0,1,1.15.16,6.84,6.84,0,0,1,.87.26,5.89,5.89,0,0,1,.67.3,3.82,3.82,0,0,1,.58.37,3,3,0,0,1,.56.56,2,2,0,0,1,.34.71,1.73,1.73,0,0,1,0,.6c0,.1-.17.18-.36.17s-.31-.1-.3-.2a1.36,1.36,0,0,0,0-.45,1.68,1.68,0,0,0-.26-.62,2.71,2.71,0,0,0-.36-.41A3.35,3.35,0,0,0,89.47,69.84Z",
    transform: "translate(-1.65)",
    fill: "#dcdadb"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M89,70.13a2,2,0,0,1,.88.92,1.2,1.2,0,0,1,.08.62c0,.1-.17.18-.35.17s-.32-.09-.32-.2,0-.14,0-.2a1.13,1.13,0,0,0-.36-.72,2.32,2.32,0,0,0-.7-.47,4.23,4.23,0,0,0-1.51-.32h-.38a.43.43,0,0,1-.3-.08.13.13,0,0,1,0-.2.37.37,0,0,1,.26-.1,5.44,5.44,0,0,1,1.46.11,4.73,4.73,0,0,1,.78.24A3.39,3.39,0,0,1,89,70.13Z",
    transform: "translate(-1.65)",
    fill: "#dcdadb"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M88.09,70.7a.94.94,0,0,1,.54.84.16.16,0,0,1-.06.14.47.47,0,0,1-.45.06c-.12,0-.17-.1-.16-.19a.53.53,0,0,0-.22-.48,1.58,1.58,0,0,0-1-.36h-.28a.41.41,0,0,1-.34-.13c0-.09,0-.18.13-.22l.17,0a3.67,3.67,0,0,1,1.06.12A2.88,2.88,0,0,1,88.09,70.7Z",
    transform: "translate(-1.65)",
    fill: "#dcdadb"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M86.14,71.76c-.27-.15-.27-.39,0-.54a1,1,0,0,1,1,0c.27.16.27.4,0,.55A1.06,1.06,0,0,1,86.14,71.76Z",
    transform: "translate(-1.65)",
    fill: "#dcdadb"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M115.62,55.43a2.7,2.7,0,0,1-2.43,0c-.68-.39-.68-1,0-1.4a2.69,2.69,0,0,1,2.44,0A.75.75,0,0,1,115.62,55.43Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M104.71,63.48c-.94.1-1.84-.26-2-.8s.43-1.06,1.36-1.16,1.84.26,2,.8S105.64,63.38,104.71,63.48Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M102.43,60.61c-.15.54-1,.91-2,.82s-1.58-.61-1.43-1.15,1-.91,2-.82S102.58,60.06,102.43,60.61Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M97,60.84c.83.27,1.13.88.67,1.36a2.48,2.48,0,0,1-2.34.38c-.84-.27-1.13-.88-.67-1.36A2.48,2.48,0,0,1,97,60.84Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9,64.31a2.67,2.67,0,0,1,2.42-.13c.74.34.85,1,.25,1.4a2.67,2.67,0,0,1-2.42.13C95.41,65.36,95.3,64.74,95.9,64.31Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M100.83,65.68c-.49-.48-.23-1.09.59-1.37a2.51,2.51,0,0,1,2.36.36c.49.47.23,1.08-.59,1.36A2.54,2.54,0,0,1,100.83,65.68Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M109.83,63.81c-1,0-1.75-.43-1.77-1s.73-1,1.68-1,1.74.42,1.77,1S110.78,63.8,109.83,63.81Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M107.8,66.47c-.84-.27-1.15-.88-.69-1.36a2.48,2.48,0,0,1,2.33-.39c.84.27,1.15.87.69,1.36A2.48,2.48,0,0,1,107.8,66.47Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M103.73,68.17c-.49-.47-.24-1.08.57-1.36a2.53,2.53,0,0,1,2.37.33c.5.48.24,1.09-.57,1.37A2.57,2.57,0,0,1,103.73,68.17Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M98.72,68.47c0-.55.73-1,1.68-1s1.74.42,1.77,1-.73,1-1.68,1S98.75,69,98.72,68.47Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M94.11,67.28a2.48,2.48,0,0,1,2.33-.39c.84.27,1.15.88.7,1.36a2.51,2.51,0,0,1-2.34.39C94,68.37,93.65,67.77,94.11,67.28Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M91.12,64.93a2.5,2.5,0,0,1,2.37.34c.5.47.25,1.08-.57,1.36a2.54,2.54,0,0,1-2.37-.34C90.06,65.82,90.31,65.21,91.12,64.93Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M90.57,62c1,0,1.75.43,1.77,1s-.73,1-1.68,1-1.74-.42-1.77-1S89.62,62,90.57,62Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6,59.38c.84.26,1.15.87.69,1.35a2.48,2.48,0,0,1-2.33.39c-.84-.27-1.15-.87-.7-1.35A2.45,2.45,0,0,1,92.6,59.38Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M96.67,57.67c.49.47.24,1.08-.57,1.36a2.53,2.53,0,0,1-2.37-.33c-.5-.47-.25-1.09.57-1.37A2.57,2.57,0,0,1,96.67,57.67Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M101.68,57.37c0,.55-.73,1-1.68,1s-1.74-.42-1.77-1,.73-1,1.68-1S101.65,56.82,101.68,57.37Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M114.13,66.13c-.92-.15-1.47-.69-1.23-1.22a2.05,2.05,0,0,1,2.11-.7c.92.14,1.47.69,1.23,1.22A2.07,2.07,0,0,1,114.13,66.13Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M111.42,68.68c-.78-.32-1-.94-.43-1.39a2.63,2.63,0,0,1,2.4-.24c.78.32,1,.94.43,1.39A2.6,2.6,0,0,1,111.42,68.68Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M107.36,70.53c-.55-.45-.37-1.07.41-1.38a2.63,2.63,0,0,1,2.4.25c.55.45.37,1.07-.41,1.38A2.57,2.57,0,0,1,107.36,70.53Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M102.43,71.47c-.25-.53.29-1.07,1.21-1.21a2.09,2.09,0,0,1,2.12.7c.25.53-.3,1.08-1.22,1.22A2.07,2.07,0,0,1,102.43,71.47Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M97.23,71.38c.08-.55.92-.95,1.87-.9s1.65.53,1.57,1.08-.92,1-1.86.9S97.15,71.93,97.23,71.38Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M85.24,62.65c1,0,1.79.36,1.87.91s-.61,1-1.56,1.07-1.79-.36-1.87-.9S84.29,62.7,85.24,62.65Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M86.27,59.71c.92.15,1.47.69,1.22,1.22a2,2,0,0,1-2.1.7c-.92-.14-1.47-.69-1.23-1.22A2.07,2.07,0,0,1,86.27,59.71Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M89,57.16c.78.32,1,.94.43,1.39a2.6,2.6,0,0,1-2.4.24c-.78-.32-1-.94-.43-1.39A2.63,2.63,0,0,1,89,57.16Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M93,55.31c.55.45.37,1.07-.41,1.38a2.6,2.6,0,0,1-2.4-.25c-.55-.45-.37-1.07.41-1.38A2.6,2.6,0,0,1,93,55.31Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M98,54.37c.25.53-.29,1.07-1.21,1.22a2.09,2.09,0,0,1-2.12-.71c-.25-.53.3-1.08,1.22-1.22A2.08,2.08,0,0,1,98,54.37Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M118.48,58a2.51,2.51,0,0,1-2.35-.37c-.48-.48-.2-1.08.62-1.36a2.54,2.54,0,0,1,2.36.37C119.58,57.12,119.3,57.73,118.48,58Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M120.09,60.91A2.08,2.08,0,0,1,118,60.2c-.25-.53.29-1.08,1.21-1.22a2.09,2.09,0,0,1,2.12.71C121.56,60.22,121,60.77,120.09,60.91Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M120.35,64c-.95,0-1.72-.45-1.73-1s.77-1,1.72-1,1.73.45,1.73,1S121.3,64,120.35,64Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M119.24,66.93c-.93-.15-1.47-.69-1.23-1.22a2,2,0,0,1,2.11-.7c.92.14,1.47.69,1.22,1.22A2,2,0,0,1,119.24,66.93Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M116.82,69.63c-.82-.28-1.11-.89-.64-1.36a2.5,2.5,0,0,1,2.36-.36c.82.27,1.11.88.63,1.36A2.53,2.53,0,0,1,116.82,69.63Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M113.27,71.87a.74.74,0,0,1,0-1.4,2.69,2.69,0,0,1,2.44,0,.75.75,0,0,1,0,1.41A2.72,2.72,0,0,1,113.27,71.87Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M108.84,73.51c-.48-.48-.2-1.09.62-1.36a2.54,2.54,0,0,1,2.36.37c.48.47.2,1.08-.63,1.36A2.54,2.54,0,0,1,108.84,73.51Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M103.81,74.42c-.25-.53.29-1.08,1.21-1.22a2.09,2.09,0,0,1,2.12.71c.25.53-.29,1.08-1.21,1.22A2.09,2.09,0,0,1,103.81,74.42Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M98.54,74.55c0-.55.77-1,1.72-1s1.72.45,1.73,1-.77,1-1.72,1S98.54,75.1,98.54,74.55Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M93.38,73.89a2,2,0,0,1,2.11-.7c.92.14,1.47.69,1.22,1.22a2,2,0,0,1-2.1.7C93.68,75,93.14,74.42,93.38,73.89Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3,64.93a2.09,2.09,0,0,1,2.12.71c.25.53-.29,1.08-1.21,1.22a2.09,2.09,0,0,1-2.12-.71C78.84,65.62,79.39,65.07,80.3,64.93Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M80.05,61.89c1,0,1.72.45,1.73,1s-.77,1-1.72,1-1.73-.45-1.73-1S79.1,61.89,80.05,61.89Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M81.16,58.91c.92.15,1.47.7,1.23,1.23a2.06,2.06,0,0,1-2.11.7c-.92-.15-1.47-.7-1.22-1.23A2,2,0,0,1,81.16,58.91Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M83.58,56.21c.82.28,1.11.89.64,1.36a2.5,2.5,0,0,1-2.36.36c-.82-.27-1.11-.88-.63-1.36A2.53,2.53,0,0,1,83.58,56.21Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M87.12,54a.74.74,0,0,1,0,1.41,2.72,2.72,0,0,1-2.44,0,.75.75,0,0,1,0-1.41A2.7,2.7,0,0,1,87.12,54Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M91.56,52.33c.48.48.2,1.09-.62,1.36a2.51,2.51,0,0,1-2.36-.37c-.48-.47-.2-1.08.63-1.35A2.51,2.51,0,0,1,91.56,52.33Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M96.59,51.42c.25.53-.3,1.08-1.21,1.22a2.09,2.09,0,0,1-2.12-.71c-.25-.53.29-1.08,1.21-1.22A2.09,2.09,0,0,1,96.59,51.42Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M101.86,51.29c0,.55-.77,1-1.72,1s-1.72-.44-1.73-1,.77-1,1.72-1S101.86,50.74,101.86,51.29Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M107,52a2.06,2.06,0,0,1-2.11.7c-.92-.15-1.47-.7-1.22-1.23a2,2,0,0,1,2.1-.7C106.71,50.88,107.26,51.42,107,52Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M111.71,53.37a2.53,2.53,0,0,1-2.35.36c-.82-.28-1.11-.89-.64-1.36a2.5,2.5,0,0,1,2.36-.36C111.9,52.28,112.19,52.89,111.71,53.37Z",
    transform: "translate(-1.65)",
    fill: "#181011"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M111.5,61.91,102,56.44c-1.19-.68-1-1.88.33-2.67h0a5.13,5.13,0,0,1,4.63-.19l9.47,5.47c1.18.68,1,1.88-.34,2.67h0A5.13,5.13,0,0,1,111.5,61.91Z",
    transform: "translate(-1.65)",
    fill: "#2f2e30"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M111.78,61.82l-9.58-5.53c-1.08-.63-1-1.72.3-2.44h0a4.71,4.71,0,0,1,4.22-.18l9.58,5.53c1.08.63,1,1.72-.3,2.44h0A4.71,4.71,0,0,1,111.78,61.82Z",
    transform: "translate(-1.65)",
    fill: "#434345"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M107.24,56.57a4.26,4.26,0,0,1-3.84,0c-1.06-.62-1.07-1.61,0-2.22a4.23,4.23,0,0,1,3.84,0A1.17,1.17,0,0,1,107.24,56.57Z",
    transform: "translate(-1.65)",
    fill: "#2f2e30"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M115.24,61.19a4.26,4.26,0,0,1-3.84,0c-1.06-.62-1.07-1.61,0-2.22a4.26,4.26,0,0,1,3.84,0C116.29,59.59,116.3,60.58,115.24,61.19Z",
    transform: "translate(-1.65)",
    fill: "#2f2e30"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M115,61.2a3.77,3.77,0,0,1-3.4,0c-.94-.55-.94-1.42,0-2a3.77,3.77,0,0,1,3.4,0C116,59.79,116,60.66,115,61.2Z",
    transform: "translate(-1.65)",
    fill: "#49494a"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M107,56.58a3.77,3.77,0,0,1-3.4,0,1,1,0,0,1,0-2,3.77,3.77,0,0,1,3.4,0C108,55.17,108,56.05,107,56.58Z",
    transform: "translate(-1.65)",
    fill: "#49494a"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M106.8,56.35a3.3,3.3,0,0,1-3,0,.9.9,0,0,1,0-1.71,3.25,3.25,0,0,1,3,0C107.62,55.11,107.62,55.87,106.8,56.35Z",
    transform: "translate(-1.65)",
    fill: "#585859"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M114.82,61a3.3,3.3,0,0,1-3,0c-.82-.48-.83-1.25,0-1.72a3.27,3.27,0,0,1,3,0A.9.9,0,0,1,114.82,61Z",
    transform: "translate(-1.65)",
    fill: "#585859"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "103.82 56.21 102.61 55.51 103.64 54.92 104.85 55.62 103.82 56.21",
    fill: "#dcdadb"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "111.82 60.89 110.61 60.19 111.63 59.6 112.85 60.3 111.82 60.89",
    fill: "#dcdadb"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M72.21,110.5c0,.69-.25,1.26-.56,1.26s-.55-.57-.55-1.26.25-1.27.55-1.27S72.21,109.8,72.21,110.5Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M72.21,114.24c0,.69-.25,1.26-.56,1.26s-.55-.57-.55-1.26.25-1.26.55-1.26S72.21,113.54,72.21,114.24Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M72.21,118c0,.7-.25,1.26-.56,1.26s-.55-.56-.55-1.26.25-1.26.55-1.26S72.21,117.28,72.21,118Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M72.21,121.72c0,.7-.25,1.27-.56,1.27s-.55-.57-.55-1.27.25-1.26.55-1.26S72.21,121,72.21,121.72Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M72.21,125.47c0,.69-.25,1.26-.56,1.26s-.55-.57-.55-1.26.25-1.26.55-1.26S72.21,124.77,72.21,125.47Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M72.21,129.21c0,.7-.25,1.26-.56,1.26s-.55-.56-.55-1.26.25-1.26.55-1.26S72.21,128.51,72.21,129.21Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M72.21,133c0,.7-.25,1.27-.56,1.27s-.55-.57-.55-1.27.25-1.26.55-1.26S72.21,132.26,72.21,133Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M72.21,136.7c0,.69-.25,1.26-.56,1.26s-.55-.57-.55-1.26.25-1.26.55-1.26S72.21,136,72.21,136.7Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M72.21,140.44c0,.7-.25,1.26-.56,1.26s-.55-.56-.55-1.26.25-1.26.55-1.26S72.21,139.74,72.21,140.44Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M73.63,116.88c0,.7-.25,1.26-.55,1.26s-.56-.56-.56-1.26.25-1.26.56-1.26S73.63,116.19,73.63,116.88Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M73.63,120.63c0,.7-.25,1.26-.55,1.26s-.56-.56-.56-1.26.25-1.26.56-1.26S73.63,119.93,73.63,120.63Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M73.63,124.38c0,.7-.25,1.26-.55,1.26s-.56-.56-.56-1.26.25-1.26.56-1.26S73.63,123.68,73.63,124.38Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M73.63,128.13c0,.7-.25,1.26-.55,1.26s-.56-.56-.56-1.26.25-1.26.56-1.26S73.63,127.43,73.63,128.13Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M73.63,131.88c0,.7-.25,1.26-.55,1.26s-.56-.56-.56-1.26.25-1.26.56-1.26S73.63,131.18,73.63,131.88Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M73.63,135.63c0,.7-.25,1.26-.55,1.26s-.56-.56-.56-1.26.25-1.26.56-1.26S73.63,134.93,73.63,135.63Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M73.63,139.38c0,.7-.25,1.26-.55,1.26s-.56-.56-.56-1.26.25-1.26.56-1.26S73.63,138.68,73.63,139.38Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M73.63,143.13c0,.7-.25,1.26-.55,1.26s-.56-.56-.56-1.26.25-1.26.56-1.26S73.63,142.43,73.63,143.13Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M75.05,115.77c0,.7-.24,1.26-.55,1.26s-.55-.56-.55-1.26.24-1.26.55-1.26S75.05,115.07,75.05,115.77Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M75.05,119.51c0,.7-.24,1.26-.55,1.26s-.55-.56-.55-1.26.24-1.26.55-1.26S75.05,118.82,75.05,119.51Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M75.05,123.26c0,.69-.24,1.26-.55,1.26S74,124,74,123.26s.24-1.27.55-1.27S75.05,122.56,75.05,123.26Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M75.05,127c0,.7-.24,1.26-.55,1.26S74,127.7,74,127s.24-1.26.55-1.26S75.05,126.3,75.05,127Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M75.05,130.74c0,.7-.24,1.26-.55,1.26s-.55-.56-.55-1.26.24-1.26.55-1.26S75.05,130.05,75.05,130.74Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M75.05,134.49c0,.69-.24,1.26-.55,1.26s-.55-.57-.55-1.26.24-1.27.55-1.27S75.05,133.79,75.05,134.49Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M75.05,138.23c0,.7-.24,1.26-.55,1.26s-.55-.56-.55-1.26.24-1.26.55-1.26S75.05,137.53,75.05,138.23Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M75.05,142c0,.7-.24,1.26-.55,1.26S74,142.67,74,142s.24-1.26.55-1.26S75.05,141.27,75.05,142Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M75.05,145.71c0,.7-.24,1.27-.55,1.27s-.55-.57-.55-1.27.24-1.26.55-1.26S75.05,145,75.05,145.71Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M76.71,118.7c0,.7-.29,1.26-.65,1.26s-.64-.56-.64-1.26.29-1.26.64-1.26S76.71,118,76.71,118.7Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M76.71,122.45c0,.7-.29,1.26-.65,1.26s-.64-.56-.64-1.26.29-1.26.64-1.26S76.71,121.76,76.71,122.45Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M76.71,126.2c0,.7-.29,1.26-.65,1.26s-.64-.56-.64-1.26.29-1.26.64-1.26S76.71,125.51,76.71,126.2Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M76.71,130c0,.7-.29,1.26-.65,1.26s-.64-.56-.64-1.26.29-1.26.64-1.26S76.71,129.26,76.71,130Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M76.71,133.7c0,.7-.29,1.26-.65,1.26s-.64-.56-.64-1.26.29-1.26.64-1.26S76.71,133,76.71,133.7Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M76.71,137.45c0,.7-.29,1.26-.65,1.26s-.64-.56-.64-1.26.29-1.26.64-1.26S76.71,136.76,76.71,137.45Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M76.71,141.2c0,.7-.29,1.26-.65,1.26s-.64-.56-.64-1.26.29-1.26.64-1.26S76.71,140.5,76.71,141.2Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M76.71,145c0,.7-.29,1.26-.65,1.26s-.64-.56-.64-1.26.29-1.26.64-1.26S76.71,144.25,76.71,145Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M78.36,118.14c0,.7-.29,1.26-.64,1.26s-.64-.56-.64-1.26.28-1.26.64-1.26S78.36,117.45,78.36,118.14Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M78.36,121.89c0,.69-.29,1.26-.64,1.26s-.64-.57-.64-1.26.28-1.26.64-1.26S78.36,121.19,78.36,121.89Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M78.36,125.63c0,.7-.29,1.26-.64,1.26s-.64-.56-.64-1.26.28-1.26.64-1.26S78.36,124.93,78.36,125.63Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M78.36,129.37c0,.7-.29,1.26-.64,1.26s-.64-.56-.64-1.26.28-1.26.64-1.26S78.36,128.68,78.36,129.37Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M78.36,133.12c0,.69-.29,1.26-.64,1.26s-.64-.57-.64-1.26.28-1.27.64-1.27S78.36,132.42,78.36,133.12Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M78.36,136.86c0,.7-.29,1.26-.64,1.26s-.64-.56-.64-1.26.28-1.26.64-1.26S78.36,136.16,78.36,136.86Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M78.36,140.6c0,.7-.29,1.26-.64,1.26s-.64-.56-.64-1.26.28-1.26.64-1.26S78.36,139.91,78.36,140.6Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M78.36,144.35c0,.69-.29,1.26-.64,1.26s-.64-.57-.64-1.26.28-1.27.64-1.27S78.36,143.65,78.36,144.35Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M78.36,148.09c0,.69-.29,1.26-.64,1.26s-.64-.57-.64-1.26.28-1.26.64-1.26S78.36,147.39,78.36,148.09Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M80.69,121.79c0,.69-.4,1.26-.9,1.26s-.91-.57-.91-1.26.41-1.26.91-1.26S80.69,121.09,80.69,121.79Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M80.69,125.54c0,.69-.4,1.26-.9,1.26s-.91-.57-.91-1.26.41-1.27.91-1.27S80.69,124.84,80.69,125.54Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M80.69,129.29c0,.69-.4,1.26-.9,1.26s-.91-.57-.91-1.26.41-1.27.91-1.27S80.69,128.59,80.69,129.29Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M80.69,133c0,.69-.4,1.26-.9,1.26s-.91-.57-.91-1.26.41-1.27.91-1.27S80.69,132.34,80.69,133Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M80.69,136.79c0,.69-.4,1.26-.9,1.26s-.91-.57-.91-1.26.41-1.27.91-1.27S80.69,136.09,80.69,136.79Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M80.69,140.53c0,.7-.4,1.27-.9,1.27s-.91-.57-.91-1.27.41-1.26.91-1.26S80.69,139.84,80.69,140.53Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M80.69,144.28c0,.7-.4,1.27-.9,1.27s-.91-.57-.91-1.27.41-1.26.91-1.26S80.69,143.59,80.69,144.28Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M80.69,148c0,.7-.4,1.27-.9,1.27s-.91-.57-.91-1.27.41-1.26.91-1.26S80.69,147.34,80.69,148Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M83,120.43c0,.69-.4,1.26-.9,1.26s-.91-.57-.91-1.26.41-1.26.91-1.26S83,119.73,83,120.43Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M83,124.17c0,.7-.4,1.26-.9,1.26s-.91-.56-.91-1.26.41-1.26.91-1.26S83,123.47,83,124.17Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M83,127.91c0,.7-.4,1.27-.9,1.27s-.91-.57-.91-1.27.41-1.26.91-1.26S83,127.22,83,127.91Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M83,131.66c0,.69-.4,1.26-.9,1.26s-.91-.57-.91-1.26.41-1.26.91-1.26S83,131,83,131.66Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.47,
    cy: 135.4,
    rx: 0.91,
    ry: 1.26,
    fill: "#010101"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M83,139.14c0,.7-.4,1.27-.9,1.27s-.91-.57-.91-1.27.41-1.26.91-1.26S83,138.45,83,139.14Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M83,142.89c0,.69-.4,1.26-.9,1.26s-.91-.57-.91-1.26.41-1.26.91-1.26S83,142.19,83,142.89Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M83,146.63c0,.7-.4,1.26-.9,1.26s-.91-.56-.91-1.26.41-1.26.91-1.26S83,145.93,83,146.63Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M83,150.37c0,.7-.4,1.26-.9,1.26s-.91-.56-.91-1.26.41-1.26.91-1.26S83,149.68,83,150.37Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.8,
    cy: 123.51,
    rx: 0.91,
    ry: 1.26,
    fill: "#010101"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.8,
    cy: 127.26,
    rx: 0.91,
    ry: 1.26,
    fill: "#010101"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.8,
    cy: 131.01,
    rx: 0.91,
    ry: 1.26,
    fill: "#010101"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.8,
    cy: 134.76,
    rx: 0.91,
    ry: 1.26,
    fill: "#010101"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.8,
    cy: 138.51,
    rx: 0.91,
    ry: 1.26,
    fill: "#010101"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.8,
    cy: 142.26,
    rx: 0.91,
    ry: 1.26,
    fill: "#010101"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.8,
    cy: 146.01,
    rx: 0.91,
    ry: 1.26,
    fill: "#010101"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.8,
    cy: 149.76,
    rx: 0.91,
    ry: 1.26,
    fill: "#010101"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M88.61,122.58a1.27,1.27,0,1,1-1.27-1.26A1.26,1.26,0,0,1,88.61,122.58Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M88.61,126.33a1.27,1.27,0,1,1-1.27-1.27A1.27,1.27,0,0,1,88.61,126.33Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M88.61,130.07a1.27,1.27,0,1,1-1.27-1.26A1.27,1.27,0,0,1,88.61,130.07Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M88.61,133.81a1.27,1.27,0,1,1-1.27-1.26A1.26,1.26,0,0,1,88.61,133.81Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M88.61,137.55a1.27,1.27,0,1,1-1.27-1.26A1.27,1.27,0,0,1,88.61,137.55Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M88.61,141.3A1.27,1.27,0,1,1,87.34,140,1.27,1.27,0,0,1,88.61,141.3Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M88.61,145a1.27,1.27,0,1,1-1.27-1.26A1.26,1.26,0,0,1,88.61,145Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M88.61,148.78a1.27,1.27,0,1,1-1.27-1.26A1.27,1.27,0,0,1,88.61,148.78Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7,
    cy: 152.53,
    r: 1.26,
    fill: "#010101"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M91.85,125.67a1.26,1.26,0,1,1-1.26-1.27A1.26,1.26,0,0,1,91.85,125.67Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M91.85,129.41a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,91.85,129.41Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M91.85,133.16a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,91.85,133.16Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M91.85,136.91a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,91.85,136.91Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M91.85,140.66a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,91.85,140.66Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M91.85,144.41a1.26,1.26,0,1,1-2.52,0,1.26,1.26,0,0,1,2.52,0Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M91.85,148.16a1.26,1.26,0,1,1-2.52,0,1.26,1.26,0,0,1,2.52,0Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M91.85,151.91a1.26,1.26,0,1,1-2.52,0,1.26,1.26,0,0,1,2.52,0Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.19,
    cy: 123.84,
    r: 1.26,
    fill: "#010101"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.19,
    cy: 127.59,
    r: 1.26,
    fill: "#010101"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.19,
    cy: 131.33,
    r: 1.26,
    fill: "#010101"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.19,
    cy: 135.07,
    r: 1.26,
    fill: "#010101"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.19,
    cy: 138.82,
    r: 1.26,
    fill: "#010101"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.19,
    cy: 142.56,
    r: 1.26,
    fill: "#010101"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.19,
    cy: 146.3,
    r: 1.26,
    fill: "#010101"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.19,
    cy: 150.05,
    r: 1.26,
    fill: "#010101"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.19,
    cy: 153.79,
    r: 1.26,
    fill: "#010101"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M98.35,126.36a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,98.35,126.36Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M98.35,130.11a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,98.35,130.11Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M98.35,133.86a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,98.35,133.86Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M98.35,137.61a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,98.35,137.61Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M98.35,141.36a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,98.35,141.36Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M98.35,145.11a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,98.35,145.11Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M98.35,148.86a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,98.35,148.86Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M98.35,152.61a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,98.35,152.61Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.69,
    cy: 124.54,
    r: 1.26,
    fill: "#010101"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.69,
    cy: 128.29,
    r: 1.26,
    fill: "#010101"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.69,
    cy: 132.03,
    r: 1.26,
    fill: "#010101"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.69,
    cy: 135.77,
    r: 1.26,
    fill: "#010101"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.69,
    cy: 139.52,
    r: 1.26,
    fill: "#010101"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.69,
    cy: 143.26,
    r: 1.26,
    fill: "#010101"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.69,
    cy: 147,
    r: 1.26,
    fill: "#010101"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.69,
    cy: 150.74,
    r: 1.26,
    fill: "#010101"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.69,
    cy: 154.49,
    r: 1.26,
    fill: "#010101"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M104.85,126.36a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,104.85,126.36Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M104.85,130.11a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,104.85,130.11Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M104.85,133.86a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,104.85,133.86Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M104.85,137.61a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,104.85,137.61Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M104.85,141.36a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,104.85,141.36Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M104.85,145.11a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,104.85,145.11Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M104.85,148.86a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,104.85,148.86Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M104.85,152.61a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,104.85,152.61Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M108.1,123.84a1.26,1.26,0,1,1-1.26-1.26A1.27,1.27,0,0,1,108.1,123.84Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M108.1,127.59a1.26,1.26,0,1,1-2.52,0,1.26,1.26,0,1,1,2.52,0Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M108.1,131.33a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,108.1,131.33Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M108.1,135.07a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,108.1,135.07Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M108.1,138.82a1.26,1.26,0,1,1-1.26-1.27A1.27,1.27,0,0,1,108.1,138.82Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M108.1,142.56a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,108.1,142.56Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M108.1,146.3a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,108.1,146.3Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M108.1,150.05a1.26,1.26,0,1,1-1.26-1.27A1.27,1.27,0,0,1,108.1,150.05Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M108.1,153.79a1.26,1.26,0,0,1-2.52,0,1.26,1.26,0,0,1,2.52,0Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M111.16,125.67A1.17,1.17,0,1,1,110,124.4,1.22,1.22,0,0,1,111.16,125.67Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M111.16,129.41a1.17,1.17,0,1,1-1.17-1.26A1.22,1.22,0,0,1,111.16,129.41Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M111.16,133.16A1.17,1.17,0,1,1,110,131.9,1.22,1.22,0,0,1,111.16,133.16Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M111.16,136.91a1.17,1.17,0,1,1-1.17-1.26A1.22,1.22,0,0,1,111.16,136.91Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M111.16,140.66A1.17,1.17,0,1,1,110,139.4,1.22,1.22,0,0,1,111.16,140.66Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M111.16,144.41a1.17,1.17,0,1,1-2.34,0,1.17,1.17,0,1,1,2.34,0Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M111.16,148.16a1.17,1.17,0,1,1-2.34,0,1.17,1.17,0,1,1,2.34,0Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.35,
    cy: 151.91,
    rx: 1.17,
    ry: 1.26,
    fill: "#010101"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M113.8,122.58a1,1,0,1,1-1-1.26A1.15,1.15,0,0,1,113.8,122.58Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M113.8,126.33a1,1,0,1,1-1-1.27A1.15,1.15,0,0,1,113.8,126.33Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M113.8,130.07a1,1,0,1,1-1-1.26A1.15,1.15,0,0,1,113.8,130.07Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M113.8,133.81a1,1,0,1,1-1-1.26A1.15,1.15,0,0,1,113.8,133.81Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M113.8,137.55a1,1,0,1,1-1-1.26A1.16,1.16,0,0,1,113.8,137.55Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M113.8,141.3a1,1,0,1,1-1-1.26A1.15,1.15,0,0,1,113.8,141.3Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M113.8,145a1,1,0,1,1-1-1.26A1.15,1.15,0,0,1,113.8,145Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M113.8,148.78a1,1,0,1,1-1-1.26A1.16,1.16,0,0,1,113.8,148.78Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M113.8,152.53a1,1,0,1,1-1-1.26A1.15,1.15,0,0,1,113.8,152.53Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M116.34,123.51a1,1,0,1,1-1-1.26A1.14,1.14,0,0,1,116.34,123.51Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M116.34,127.26a1,1,0,1,1-1-1.26A1.14,1.14,0,0,1,116.34,127.26Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M116.34,131a1,1,0,1,1-1-1.26A1.14,1.14,0,0,1,116.34,131Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M116.34,134.76a1,1,0,1,1-1-1.26A1.14,1.14,0,0,1,116.34,134.76Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M116.34,138.51a1,1,0,1,1-1-1.26A1.14,1.14,0,0,1,116.34,138.51Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M116.34,142.26a1,1,0,1,1-1-1.26A1.14,1.14,0,0,1,116.34,142.26Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M116.34,146a1,1,0,1,1-1-1.26A1.14,1.14,0,0,1,116.34,146Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M116.34,149.76a1,1,0,1,1-1-1.26A1.14,1.14,0,0,1,116.34,149.76Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M118.87,120.43a1,1,0,1,1-1-1.26A1.15,1.15,0,0,1,118.87,120.43Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M118.87,124.17a1,1,0,1,1-1-1.26A1.15,1.15,0,0,1,118.87,124.17Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M118.87,127.91a1,1,0,1,1-1-1.26A1.16,1.16,0,0,1,118.87,127.91Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M118.87,131.66a1,1,0,1,1-1-1.26A1.15,1.15,0,0,1,118.87,131.66Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.24,
    cy: 135.4,
    rx: 0.98,
    ry: 1.26,
    fill: "#010101"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M118.87,139.14a1,1,0,1,1-1-1.26A1.16,1.16,0,0,1,118.87,139.14Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M118.87,142.89a1,1,0,1,1-1-1.26A1.15,1.15,0,0,1,118.87,142.89Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M118.87,146.63a1,1,0,1,1-1-1.26A1.15,1.15,0,0,1,118.87,146.63Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M118.87,150.37a1,1,0,1,1-2,0,1,1,0,1,1,2,0Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M121,121.79c0,.69-.35,1.26-.79,1.26s-.78-.57-.78-1.26.35-1.26.78-1.26S121,121.09,121,121.79Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M121,125.54c0,.69-.35,1.26-.79,1.26s-.78-.57-.78-1.26.35-1.27.78-1.27S121,124.84,121,125.54Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M121,129.29c0,.69-.35,1.26-.79,1.26s-.78-.57-.78-1.26.35-1.27.78-1.27S121,128.59,121,129.29Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M121,133c0,.69-.35,1.26-.79,1.26s-.78-.57-.78-1.26.35-1.27.78-1.27S121,132.34,121,133Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M121,136.79c0,.69-.35,1.26-.79,1.26s-.78-.57-.78-1.26.35-1.27.78-1.27S121,136.09,121,136.79Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M121,140.53c0,.7-.35,1.27-.79,1.27s-.78-.57-.78-1.27.35-1.26.78-1.26S121,139.84,121,140.53Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M121,144.28c0,.7-.35,1.27-.79,1.27s-.78-.57-.78-1.27.35-1.26.78-1.26S121,143.59,121,144.28Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M121,148c0,.7-.35,1.27-.79,1.27s-.78-.57-.78-1.27.35-1.26.78-1.26S121,147.34,121,148Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.6,
    cy: 118.14,
    rx: 0.78,
    ry: 1.26,
    fill: "#010101"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M123,121.89c0,.69-.35,1.26-.79,1.26s-.78-.57-.78-1.26.35-1.26.78-1.26S123,121.19,123,121.89Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M123,125.63c0,.7-.35,1.26-.79,1.26s-.78-.56-.78-1.26.35-1.26.78-1.26S123,124.93,123,125.63Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M123,129.37c0,.7-.35,1.26-.79,1.26s-.78-.56-.78-1.26.35-1.26.78-1.26S123,128.68,123,129.37Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M123,133.12c0,.69-.35,1.26-.79,1.26s-.78-.57-.78-1.26.35-1.27.78-1.27S123,132.42,123,133.12Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M123,136.86c0,.7-.35,1.26-.79,1.26s-.78-.56-.78-1.26.35-1.26.78-1.26S123,136.16,123,136.86Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M123,140.6c0,.7-.35,1.26-.79,1.26s-.78-.56-.78-1.26.35-1.26.78-1.26S123,139.91,123,140.6Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M123,144.35c0,.69-.35,1.26-.79,1.26s-.78-.57-.78-1.26.35-1.27.78-1.27S123,143.65,123,144.35Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M123,148.09c0,.69-.35,1.26-.79,1.26s-.78-.57-.78-1.26.35-1.26.78-1.26S123,147.39,123,148.09Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M124.63,118.7c0,.7-.25,1.26-.57,1.26s-.58-.56-.58-1.26.26-1.26.58-1.26S124.63,118,124.63,118.7Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M124.63,122.45c0,.7-.25,1.26-.57,1.26s-.58-.56-.58-1.26.26-1.26.58-1.26S124.63,121.76,124.63,122.45Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M124.63,126.2c0,.7-.25,1.26-.57,1.26s-.58-.56-.58-1.26.26-1.26.58-1.26S124.63,125.51,124.63,126.2Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M124.63,130c0,.7-.25,1.26-.57,1.26s-.58-.56-.58-1.26.26-1.26.58-1.26S124.63,129.26,124.63,130Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M124.63,133.7c0,.7-.25,1.26-.57,1.26s-.58-.56-.58-1.26.26-1.26.58-1.26S124.63,133,124.63,133.7Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M124.63,137.45c0,.7-.25,1.26-.57,1.26s-.58-.56-.58-1.26.26-1.26.58-1.26S124.63,136.76,124.63,137.45Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M124.63,141.2c0,.7-.25,1.26-.57,1.26s-.58-.56-.58-1.26.26-1.26.58-1.26S124.63,140.5,124.63,141.2Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 122.41,
    cy: 144.95,
    rx: 0.58,
    ry: 1.26,
    fill: "#010101"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M126.12,115.77c0,.7-.26,1.26-.58,1.26s-.57-.56-.57-1.26.25-1.26.57-1.26S126.12,115.07,126.12,115.77Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M126.12,119.51c0,.7-.26,1.26-.58,1.26s-.57-.56-.57-1.26.25-1.26.57-1.26S126.12,118.82,126.12,119.51Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M126.12,123.26c0,.69-.26,1.26-.58,1.26s-.57-.57-.57-1.26.25-1.27.57-1.27S126.12,122.56,126.12,123.26Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M126.12,127c0,.7-.26,1.26-.58,1.26S125,127.7,125,127s.25-1.26.57-1.26S126.12,126.3,126.12,127Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M126.12,130.74c0,.7-.26,1.26-.58,1.26s-.57-.56-.57-1.26.25-1.26.57-1.26S126.12,130.05,126.12,130.74Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M126.12,134.49c0,.69-.26,1.26-.58,1.26s-.57-.57-.57-1.26.25-1.27.57-1.27S126.12,133.79,126.12,134.49Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M126.12,138.23c0,.7-.26,1.26-.58,1.26s-.57-.56-.57-1.26.25-1.26.57-1.26S126.12,137.53,126.12,138.23Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M126.12,142c0,.7-.26,1.26-.58,1.26s-.57-.56-.57-1.26.25-1.26.57-1.26S126.12,141.27,126.12,142Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M126.12,145.71c0,.7-.26,1.27-.58,1.27s-.57-.57-.57-1.27.25-1.26.57-1.26S126.12,145,126.12,145.71Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 125.38,
    cy: 116.88,
    rx: 0.58,
    ry: 1.26,
    fill: "#010101"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M127.6,120.63c0,.7-.25,1.26-.57,1.26s-.58-.56-.58-1.26.26-1.26.58-1.26S127.6,119.93,127.6,120.63Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M127.6,124.38c0,.7-.25,1.26-.57,1.26s-.58-.56-.58-1.26.26-1.26.58-1.26S127.6,123.68,127.6,124.38Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M127.6,128.13c0,.7-.25,1.26-.57,1.26s-.58-.56-.58-1.26.26-1.26.58-1.26S127.6,127.43,127.6,128.13Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M127.6,131.88c0,.7-.25,1.26-.57,1.26s-.58-.56-.58-1.26.26-1.26.58-1.26S127.6,131.18,127.6,131.88Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M127.6,135.63c0,.7-.25,1.26-.57,1.26s-.58-.56-.58-1.26.26-1.26.58-1.26S127.6,134.93,127.6,135.63Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M127.6,139.38c0,.7-.25,1.26-.57,1.26s-.58-.56-.58-1.26.26-1.26.58-1.26S127.6,138.68,127.6,139.38Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M127.6,143.13c0,.7-.25,1.26-.57,1.26s-.58-.56-.58-1.26.26-1.26.58-1.26S127.6,142.43,127.6,143.13Z",
    transform: "translate(-1.65)",
    fill: "#010101"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 126.86,
    cy: 110.5,
    rx: 0.58,
    ry: 1.26,
    fill: "#010101"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 126.86,
    cy: 114.24,
    rx: 0.58,
    ry: 1.26,
    fill: "#010101"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 126.86,
    cy: 117.98,
    rx: 0.58,
    ry: 1.26,
    fill: "#010101"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 126.86,
    cy: 121.72,
    rx: 0.58,
    ry: 1.26,
    fill: "#010101"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 126.86,
    cy: 125.47,
    rx: 0.58,
    ry: 1.26,
    fill: "#010101"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 126.86,
    cy: 129.21,
    rx: 0.58,
    ry: 1.26,
    fill: "#010101"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 126.86,
    cy: 132.95,
    rx: 0.58,
    ry: 1.26,
    fill: "#010101"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 126.86,
    cy: 136.7,
    rx: 0.58,
    ry: 1.26,
    fill: "#010101"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 126.86,
    cy: 140.44,
    rx: 0.58,
    ry: 1.26,
    fill: "#010101"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M120.09,102.94v1l-2.77,1.68v-.95a3.44,3.44,0,0,1,1.39-2.69.85.85,0,0,1,1-.05A1.27,1.27,0,0,1,120.09,102.94Z",
    transform: "translate(-1.65)",
    fill: "#48484a"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M117.32,105.91l2.77-1.68V105a3.44,3.44,0,0,1-1.38,2.69c-.77.47-1.39,0-1.39-1Z",
    transform: "translate(-1.65)",
    fill: "#48484a"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M116.84,106.33a.94.94,0,0,1-.37.73c-.21.13-.37,0-.37-.27a.91.91,0,0,1,.37-.73C116.67,105.93,116.84,106.06,116.84,106.33Z",
    transform: "translate(-1.65)",
    fill: "#48484a"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M121.31,103.61a.91.91,0,0,1-.37.73c-.2.13-.37,0-.37-.28a.93.93,0,0,1,.37-.72C121.15,103.21,121.31,103.34,121.31,103.61Z",
    transform: "translate(-1.65)",
    fill: "#48484a"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "117.36 110.16 116.75 110.53 116.75 108.45 117.36 108.08 117.36 110.16",
    fill: "#48484a"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "117.91 109.52 117.91 110.43 116.2 111.46 116.2 110.56 117.91 109.52",
    fill: "#48484a"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M118.71,108.65c-.78.47-1.39.53-1.82.17-.7-.59-.62-2.1-.61-2.16l.38-.2s-.07,1.36.52,1.85c.34.29.86.23,1.53-.18Z",
    transform: "translate(-1.65)",
    fill: "#48484a"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M118.71,108.65v-.52a4,4,0,0,0,1.53-1.69,5.6,5.6,0,0,0,.51-2.46l.38-.28a6.27,6.27,0,0,1-.61,2.92A4.9,4.9,0,0,1,118.71,108.65Z",
    transform: "translate(-1.65)",
    fill: "#48484a"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M180.34,198.15a12.41,12.41,0,0,1-3.31,5.33,10.19,10.19,0,0,1-7.66,3c-8.86-.3-18.28-10.21-18.81-10.78l0,0,13.7-7.91C164.33,187.82,172.16,196.25,180.34,198.15Z",
    transform: "translate(-1.65)",
    fill: "#b01f24"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M180,195.27l-1,2.52c-1.18,1.05-8.35,7.07-13.7,7.92l1-2.52c-7.47-2.89-23.17-14.1-24.09-30.29-.33-5.83.76-9.89,3.22-12.08a7.6,7.6,0,0,1,5.88-1.71l4.94-.52a25.63,25.63,0,0,0-.33,6.39C156.85,181.18,172.56,192.39,180,195.27Z",
    transform: "translate(-1.65)",
    fill: "url(#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_866)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M162.46,193.65a5.66,5.66,0,0,1,5,1.07c1.21,1.1.94,2.39-.61,2.89a5.6,5.6,0,0,1-5-1.08C160.64,195.44,160.91,194.15,162.46,193.65Z",
    transform: "translate(-1.65)",
    fill: "#a61e22"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M166.32,203.19l-1,2.52c-9.73-5.85-13.81-11.43-17.43-15.33-4.21-4.54-6.16-10.79-6.69-20.26-.16-2.71.56-3.67,1-5.75a18,18,0,0,1,2.56-6.41h0c.45-.58,13.09-7.48,13.31-7.65a10.37,10.37,0,0,1,7.46-1.77L165,151.2a7.59,7.59,0,0,0-5.88,1.71,9.26,9.26,0,0,0-2.7,4.82c-.07.28-.14.56-.19.86l-4.94.52a7.6,7.6,0,0,0-5.88,1.71c-2.46,2.19-3.55,6.25-3.22,12.08C143.15,189.09,158.85,200.3,166.32,203.19Z",
    transform: "translate(-1.65)",
    fill: "#d02027"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M166.32,203.19l-1,2.52a46.38,46.38,0,0,1-15.94-11.27c-4.2-4.53-9.33-11.92-9.86-21.39-.38-6.72,1-11.52,4.16-14.28a7.85,7.85,0,0,1,1.06-.81h0a10.43,10.43,0,0,1,7.06-1.51l4.64,1.28,2.19.6-2.38.26-4.94.52a7.6,7.6,0,0,0-5.88,1.71c-2.46,2.19-3.55,6.25-3.22,12.08C143.15,189.09,158.85,200.3,166.32,203.19Z",
    transform: "translate(-1.65)",
    fill: "#a61e22"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M191.32,164.75h0a6.85,6.85,0,0,0,1.94-4.71,5.17,5.17,0,0,0-2.08-3.81l-10.18-.6-7.75-4.47c-2.32-1.34-5.86-1.49-7.86-.33l-8.17,4.72L148.7,155a4.7,4.7,0,0,0-2,4.23,5.61,5.61,0,0,0,2.3,4.82h0a5,5,0,0,0,.84.59l16.73,9.66c2.32,1.34,5.85,1.48,7.86.32l16.13-9.31a3.47,3.47,0,0,0,.72-.54Z",
    transform: "translate(-1.65)",
    fill: "url(#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_800)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M193.27,159.69a5.24,5.24,0,0,0-2.07-3.47l-2.38-.14-15.4-8.89c-2.47-1.43-6.24-1.58-8.38-.35l-14.37,8.31-2-.12a4.8,4.8,0,0,0-1.86,3.27,2.14,2.14,0,0,0-.08.75h0a3.27,3.27,0,0,0,1.84,2.46l4.79,2.77,13,7.52c2.47,1.42,6.24,1.58,8.38.35l13-7.53,4-2.32a2.7,2.7,0,0,0,1.39-1.64,4.48,4.48,0,0,0,.07-.64C193.29,159.91,193.29,159.8,193.27,159.69Z",
    transform: "translate(-1.65)",
    fill: "url(#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_796)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M174.43,169.14l16.13-9.32c2-1.15,1.75-3.2-.57-4.54l-16.72-9.65c-2.32-1.34-5.86-1.49-7.86-.33l-16.13,9.31c-2,1.16-1.75,3.21.56,4.55l16.73,9.65C168.89,170.15,172.42,170.29,174.43,169.14Z",
    transform: "translate(-1.65)",
    fill: "#fdfdfc"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M174,168.54l15.52-9c1.78-1,1.55-2.83-.49-4l-16.27-9.39a7.75,7.75,0,0,0-6.94-.29l-15.53,9c-1.77,1-1.54,2.83.5,4l16.27,9.39A7.72,7.72,0,0,0,174,168.54Z",
    transform: "translate(-1.65)",
    fill: "#272329"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M189.55,159.09l-8.09,4.67-7.23,4.18a7.65,7.65,0,0,1-6.86-.29l-16.05-9.26c-2-1.17-2.24-2.95-.49-4l7.07-4.09h0l8.24-4.76a7.63,7.63,0,0,1,6.85.29l16.06,9.26C191.07,156.3,191.3,158.08,189.55,159.09Z",
    transform: "translate(-1.65)",
    fill: "#262525"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M172.5,167.09l15.31-8.84c1.08-.62.94-1.72-.3-2.44l-15.95-9.2a4.71,4.71,0,0,0-4.22-.18L152,155.27c-1.08.63-.95,1.72.3,2.44l15.95,9.21A4.71,4.71,0,0,0,172.5,167.09Z",
    transform: "translate(-1.65)",
    fill: "#262525"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M173,165.63l13.67-7.89c1.08-.63,1-1.72-.3-2.44l-14-8.07a4.71,4.71,0,0,0-4.22-.18l-13.68,7.89c-1.07.63-.94,1.72.31,2.44l14,8.08A4.74,4.74,0,0,0,173,165.63Z",
    transform: "translate(-1.65)",
    fill: "#383938",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.46,163.76l-7.23,4.18a7.65,7.65,0,0,1-6.86-.29l-16.05-9.26c-2-1.17-2.24-2.95-.49-4l7.07-4.09h0l.16,0s2.43-.53,11.16,4.5C175.48,158.42,179.57,160.82,181.46,163.76Z",
    transform: "translate(-1.65)",
    fill: "#302b32",
    style: {
      mixBlendMode: "screen"
    }
  }), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M155.08,165.2a5.27,5.27,0,0,0,2.39,4.12c.77.45,1.15.75,1.59.35l.39-.42a1.9,1.9,0,0,0,.4-1.29,5.27,5.27,0,0,0-2.38-4.12,2,2,0,0,0-1.26-.32l-.72.19C154.92,163.88,155.08,164.31,155.08,165.2Z",
    transform: "translate(-1.65)",
    fill: "url(#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_731)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M154.56,165.4a5.44,5.44,0,0,0,2.29,4.37,1.66,1.66,0,0,0,2.68-1.5,5.47,5.47,0,0,0-2.48-4.29,2,2,0,0,0-1.49-.29,1.09,1.09,0,0,0-.25.1,1.64,1.64,0,0,0-.75.68A2.62,2.62,0,0,0,154.56,165.4Z",
    transform: "translate(-1.65)",
    fill: "url(#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_731-2)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M154.24,165.6a5.25,5.25,0,0,0,2.39,4.12c1.32.76,2.39.15,2.39-1.36a5.27,5.27,0,0,0-2.39-4.12C155.31,163.48,154.24,164.09,154.24,165.6Z",
    transform: "translate(-1.65)",
    fill: "#9f9b98"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M154.41,166.08a4.28,4.28,0,0,0,1.87,3.3l.07,0c1.07.62,1.93.12,1.93-1.1a4.25,4.25,0,0,0-1.9-3.32l0,0-.07,0C155.24,164.38,154.41,164.88,154.41,166.08Z",
    transform: "translate(-1.65)",
    fill: "#413c42"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M192.59,197.53a14,14,0,0,1-3.11,2.25c-1.83,1-12.84,8.5-15,8.51h0c-.17,0-4.71-.79-4.88-.79-1,0-4-.65-5-.86-9-1.94-13.48-10.32-14-11,.53.57,9.95,10.48,18.81,10.78a10.19,10.19,0,0,0,7.66-3,12.41,12.41,0,0,0,3.31-5.33c.33.08.65.14,1,.2.58.09.72-2.22,1.2-5.21.55-3.36-5.53-21.06-5.75-21.53h0l13.7-7.91A54.33,54.33,0,0,1,196,176.07C198.79,185.34,197.6,192.76,192.59,197.53Z",
    transform: "translate(-1.65)",
    fill: "url(#_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_865)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M178.89,205.44a13.3,13.3,0,0,1-4.44,2.85,12.79,12.79,0,0,1-4.68.85h-.5c-10.21-.35-20.3-11.22-20.72-11.68l2-1.83,0,0c.53.57,9.95,10.48,18.81,10.78a10.19,10.19,0,0,0,7.66-3,12.41,12.41,0,0,0,3.31-5.33c3.33-10.45-5.74-24.92-5.85-25.09l2.28-1.45h0A54.87,54.87,0,0,1,182.32,184C185.09,193.25,183.9,200.67,178.89,205.44Z",
    transform: "translate(-1.65)",
    fill: "#a61e22"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M163.36,193.65a5.64,5.64,0,0,1,5,1.07c.71.64,1.14.93.88,1.51l-.29.54a2.05,2.05,0,0,1-1.19.84,5.63,5.63,0,0,1-5-1.08,2.16,2.16,0,0,1-.73-1.18c0-.07,0-.72-.05-.79C162,193.93,162.46,193.94,163.36,193.65Z",
    transform: "translate(-1.65)",
    fill: "#7f8080"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M163.4,193.06a5.82,5.82,0,0,1,5.21.89,1.78,1.78,0,0,1-.65,3.23,5.89,5.89,0,0,1-5.19-1.12,2.11,2.11,0,0,1-.79-1.42,1.36,1.36,0,0,1,0-.29,1.68,1.68,0,0,1,.44-1A2.8,2.8,0,0,1,163.4,193.06Z",
    transform: "translate(-1.65)",
    fill: "#9c9c9d"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M163.5,192.66a5.66,5.66,0,0,1,5,1.08c1.21,1.09.94,2.39-.6,2.88a5.64,5.64,0,0,1-5-1.07C161.69,194.45,162,193.16,163.5,192.66Z",
    transform: "translate(-1.65)",
    fill: "#bdbdbd"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M163.91,193a4.56,4.56,0,0,1,4,.82.18.18,0,0,1,.07,0c1,.89.76,1.93-.49,2.34a4.6,4.6,0,0,1-4-.84l0,0-.06-.06A1.25,1.25,0,0,1,163.91,193Z",
    transform: "translate(-1.65)",
    fill: "#d2d2d2"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "23.56 260.56 33.31 268.46 33.31 256.38 23.56 248.49 23.56 260.56",
    fill: "#f9a25e"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "43.06 260.56 52.8 268.46 52.8 256.38 43.06 248.49 43.06 260.56",
    fill: "#c8da2c"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "43.06 260.56 33.31 268.46 33.31 256.38 43.06 248.49 43.06 260.56",
    fill: "#ffcf6e"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "23.56 260.56 13.81 268.46 13.81 256.38 23.56 248.49 23.56 260.56",
    fill: "#ef4e77"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "23.56 244.66 33.31 252.56 33.31 244.37 23.56 236.47 23.56 244.66",
    fill: "#f9a25e"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "43.06 244.66 52.8 252.56 52.8 244.37 43.06 236.47 43.06 244.66",
    fill: "#c8da2c"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "43.06 244.66 33.31 252.56 33.31 244.37 43.06 236.47 43.06 244.66",
    fill: "#ffcf6e"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "23.56 244.66 13.81 252.56 13.81 244.37 23.56 236.47 23.56 244.66",
    fill: "#ef4e77"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M66.17,267.88V251.39a3.31,3.31,0,0,1,3.64-3.63c2,0,3,.79,3.8,2.85l4.6,11.65h.12l4.59-11.65c.81-2.06,1.86-2.85,3.83-2.85a3.29,3.29,0,0,1,3.62,3.63v16.49a2.47,2.47,0,1,1-4.93,0V256.37h-.11l-4.9,12.14a2.29,2.29,0,0,1-4.31,0l-4.89-12.14h-.12v11.51a2.47,2.47,0,1,1-4.94,0Z",
    transform: "translate(-1.65)",
    fill: "#575757"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M93.21,273.78a1.72,1.72,0,0,1,2-1.73h.71a2.2,2.2,0,0,0,1.93-.91l.14-.32-5.08-13.52a5,5,0,0,1-.33-1.64,2.62,2.62,0,0,1,2.82-2.52c1.46,0,2.19.61,2.63,2.23l3.12,10.7h.09l3.12-10.76a2.5,2.5,0,0,1,2.62-2.17,2.44,2.44,0,0,1,2.65,2.41,5.66,5.66,0,0,1-.32,1.65L104.67,270c-1.6,4.53-3.82,6.28-7.91,6.28C94.47,276.27,93.21,275.38,93.21,273.78Z",
    transform: "translate(-1.65)",
    fill: "#575757"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M111.64,267.88V251.39a3.3,3.3,0,0,1,3.64-3.63c2,0,3,.79,3.8,2.85l4.6,11.65h.12l4.59-11.65c.8-2.06,1.86-2.85,3.83-2.85a3.29,3.29,0,0,1,3.62,3.63v16.49a2.47,2.47,0,1,1-4.93,0V256.37h-.11l-4.91,12.14a2.09,2.09,0,0,1-2.13,1.51,2.12,2.12,0,0,1-2.17-1.51l-4.89-12.14h-.12v11.51a2.47,2.47,0,1,1-4.94,0Z",
    transform: "translate(-1.65)",
    fill: "#575757"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M138.3,261.81c0-5.44,3.35-8.7,8.51-8.7s8.51,3.25,8.51,8.7-3.27,8.73-8.51,8.73S138.3,267.36,138.3,261.81Zm11.54,0c0-3-1.18-4.75-3-4.75s-3,1.75-3,4.75,1.15,4.73,3,4.73S149.84,264.87,149.84,261.83Z",
    transform: "translate(-1.65)",
    fill: "#575757"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M160.52,267.71l-3.85-10.5a5,5,0,0,1-.31-1.65,2.48,2.48,0,0,1,2.72-2.41,2.51,2.51,0,0,1,2.6,2.2l2.78,10.25h.1l2.75-10.33a2.62,2.62,0,0,1,5.18.26,5.33,5.33,0,0,1-.3,1.55l-3.85,10.63a3.6,3.6,0,0,1-3.82,2.78A3.69,3.69,0,0,1,160.52,267.71Z",
    transform: "translate(-1.65)",
    fill: "#575757"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M173.37,261.91c0-5.4,3.2-8.8,8.28-8.8s8.2,3.26,8.2,7.76a2,2,0,0,1-2.18,2.14h-9v.3a3.17,3.17,0,0,0,3.29,3.39,4.75,4.75,0,0,0,3.71-1.69,2.16,2.16,0,0,1,1.68-.72,1.89,1.89,0,0,1,2,1.89,2.29,2.29,0,0,1-.37,1.23c-1.1,1.95-3.78,3.13-7.1,3.13C176.53,270.54,173.37,267.31,173.37,261.91Zm11.38-2a2.91,2.91,0,0,0-3-3,3,3,0,0,0-3.05,3Z",
    transform: "translate(-1.65)",
    fill: "#575757"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "33.34 272.88 33.34 284.96 52.8 269.2 45.29 263.12 33.34 272.88",
    fill: "#729ad1"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "21.32 263.12 13.81 269.2 33.27 284.96 33.27 272.88 21.32 263.12",
    fill: "#a54298"
  })), /*#__PURE__*/React.createElement("g", {
    id: "face"
  }, _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M391.8,111.28c-.36,4.7-2,8.18-3.74,7.78a1.81,1.81,0,0,1-.85-.57,23.32,23.32,0,0,1-3.62,9.21c-3.92,5.87-10.44,13.46-19.62,13.64a17.18,17.18,0,0,1-2.59-.21c-8.09-1.29-15-8.11-18.56-13.43a23.17,23.17,0,0,1-3.6-9.13l-.21.18a1.5,1.5,0,0,1-.4.2c-1.69.55-3.46-2.79-3.94-7.46s.48-8.89,2.18-9.44c.67-.21,1.36.2,2,1.07.95-9.76,3.09-18.44,7.12-24.53a20.22,20.22,0,0,1,34.51,0c4,6.07,6.17,14.72,7.12,24.44.55-.77,1.18-1.15,1.8-1C391.08,102.43,392.17,106.57,391.8,111.28Z",
    transform: "translate(-1.65)",
    fill: "#fdd7c7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M374.85,96.56a6.05,6.05,0,0,0-2.13-.89,6.68,6.68,0,0,0-2.77.07c-1.89.45-3.59,1.25-5.31,1.59a11.86,11.86,0,0,1-5-.25c-1.65-.37-3.35-.7-5.08-1,1.56.54,3.12,1,4.73,1.5a15.14,15.14,0,0,0,2.55.52,9.45,9.45,0,0,0,2.89-.13c1.95-.41,3.65-1.25,5.35-1.75A7.33,7.33,0,0,1,374.85,96.56Z",
    transform: "translate(-1.65)",
    fill: "#e6e7e7",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.34,94.23a5.64,5.64,0,0,0-2-1,6.49,6.49,0,0,0-2.73-.12c-1.9.33-3.66,1-5.4,1.26a11,11,0,0,1-4.92-.59c-1.58-.48-3.21-.94-4.88-1.35,1.46.66,2.94,1.28,4.47,1.85a15.62,15.62,0,0,0,2.45.7,9.09,9.09,0,0,0,2.86,0c2-.28,3.73-1,5.46-1.41A6.89,6.89,0,0,1,373.34,94.23Z",
    transform: "translate(-1.65)",
    fill: "#e6e7e7",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.06,95.17a4.93,4.93,0,0,0-1.79-.75,5.7,5.7,0,0,0-2.32,0c-1.57.37-3,1-4.44,1.32a9.69,9.69,0,0,1-4.19-.22c-1.37-.31-2.78-.59-4.22-.84,1.29.46,2.59.88,3.92,1.27a13.59,13.59,0,0,0,2.13.44,7.88,7.88,0,0,0,2.41-.11c1.63-.34,3.05-1,4.47-1.45A6.12,6.12,0,0,1,374.06,95.17Z",
    transform: "translate(-1.65)",
    fill: "#e6e7e7",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.27,121.06a14.27,14.27,0,0,0-1.74,2.2,10.78,10.78,0,0,0-1.25,2.55,4.2,4.2,0,0,0,.09,2.8,4.8,4.8,0,0,0,1.7,2.12,5.86,5.86,0,0,1-1.42-2.23,4.32,4.32,0,0,1,0-2.59,14.33,14.33,0,0,1,1.13-2.5A27.38,27.38,0,0,1,352.27,121.06Z",
    transform: "translate(-1.65)",
    fill: "#e6e7e7",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.45,121.31a12.35,12.35,0,0,1,1.6,2,9.89,9.89,0,0,1,1.14,2.33,4.21,4.21,0,0,1-.08,2.67,5.12,5.12,0,0,1-1.53,2.17,6.41,6.41,0,0,0,1.28-2.25,4.33,4.33,0,0,0,0-2.47,12.75,12.75,0,0,0-1-2.3A24.21,24.21,0,0,0,375.45,121.31Z",
    transform: "translate(-1.65)",
    fill: "#e6e7e7",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M337.6,104.89a1.23,1.23,0,0,0-1,.47,3.66,3.66,0,0,0-.74,1.42l-.11.44a3.69,3.69,0,0,0-.08.46c-.06.31-.07.63-.1.95a3.69,3.69,0,0,0,0,.47v.47c0,.32,0,.62,0,.93a20.43,20.43,0,0,0,.57,3.54,8.6,8.6,0,0,0,.59,1.55,3.37,3.37,0,0,0,.19.32,2.27,2.27,0,0,0,.21.28,1,1,0,0,0,.5.33,2.85,2.85,0,0,1-.7-1.21,12.11,12.11,0,0,1-.4-1.55,30.89,30.89,0,0,1-.43-3.38,11.64,11.64,0,0,1,.11-3.3,4.23,4.23,0,0,1,.51-1.36A2.2,2.2,0,0,1,337.6,104.89Z",
    transform: "translate(-1.65)",
    fill: "#b99a8b"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M387.84,116.26a1.07,1.07,0,0,0,1.05.1,2.24,2.24,0,0,0,.95-.94l.19-.36c.06-.13.1-.27.15-.4a7.46,7.46,0,0,0,.26-.84,3.48,3.48,0,0,0,.1-.44l.08-.45c.06-.3.08-.61.12-.91a21.39,21.39,0,0,0,.09-3.67,11.46,11.46,0,0,0-.28-1.8c0-.14-.08-.28-.13-.41s-.1-.26-.15-.39a1.71,1.71,0,0,0-.41-.57,4.27,4.27,0,0,1,.44,1.53,13.45,13.45,0,0,1,.11,1.69,30.55,30.55,0,0,1-.19,3.45,10.48,10.48,0,0,1-.69,3.08,2.58,2.58,0,0,1-.72,1A1.38,1.38,0,0,1,387.84,116.26Z",
    transform: "translate(-1.65)",
    fill: "#b99a8b"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M380.83,66.55A9.18,9.18,0,0,0,378,64.68a1.23,1.23,0,0,1-.4-.23s0-.08,0-.13c-.07-.38.3-.7.66-.77a7.93,7.93,0,0,0,1.08-.12,1.48,1.48,0,0,0-.66-.41,1.88,1.88,0,0,0-1.09-.22c-.89,0-1.68.48-2.58.32l-.21-.07c-.33-.23-.44-.61-.69-1.11a3.17,3.17,0,0,0-.87-1.16,1.3,1.3,0,0,0-.89-.23.68.68,0,0,0-.62.16,3,3,0,0,1,1.17.78.4.4,0,0,1,.09.2c0,.25-.39.29-.66.24q-1-.16-2-.36h0l-.57-.14v0a38.66,38.66,0,0,0-8.43-.91,27.65,27.65,0,0,0-7.87,1.74,23.27,23.27,0,0,0-9.35,5.64c-4.85,4.74-8,11.72-9.16,20.19-.65,5.54-.14,10.8,1.54,14.86a.5.5,0,0,1,0,.13c.18,1,2.61,15,2.68,15.52a.13.13,0,0,0,0,.06c.09.43.19.89.3,1.36,0,0,0,.16,0,.14.68,2.92,1.67,6.43,2.94,8.34,3.75,5.91,10.61,12.71,18.65,14.05a17.67,17.67,0,0,0,2.68.24h0c7.23-.16,13.91-5,19.85-14.27,1.5-2.26,3.88-9.8,3.5-10.11,0,0,1.12-13.73,2-16.31,0,0,0,0,0,0,1.7-4.07,2.45-8.75,2.48-14.86C391.7,83.49,391.17,75,380.83,66.55Zm-17.61,64c-4.44,0-8.11-2.82-8.58-5.51a44.33,44.33,0,0,0,17.14,0C371.3,127.77,367.66,130.59,363.22,130.59Zm23.49-11.38a18.17,18.17,0,0,1-1.95,4.17,43.07,43.07,0,0,1-7.45,8.6,1.6,1.6,0,0,1-2.64-1.14h0a9.36,9.36,0,0,0-9.55-9.16h-3.85a9.36,9.36,0,0,0-9.55,9.16h0a1.6,1.6,0,0,1-2.6,1.17,38.23,38.23,0,0,1-8.07-8.66,8.8,8.8,0,0,1-1.31-3.62.66.66,0,0,1,0-.14c.15-4.25.86-26.11,2.72-32.93a2.7,2.7,0,0,1,2-1.89c3.4-.8,11.6-2.25,17.16-2.14,3.45.06,10.48-.62,13-3.56,1.21-1.4-1.12,3.58.05,3A9.46,9.46,0,0,0,379,78.51a.69.69,0,0,1,1.16,0c4.45,6.64,5.55,17.47,6.32,23.75.26,2.08.45,11.72.56,15.15A5.29,5.29,0,0,1,386.71,119.21Z",
    transform: "translate(-1.65)",
    fill: "#f9f0e6"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M386.39,100.59a53.92,53.92,0,0,0-9.84-1.53c-6.53,0-10,2.71-12.92,2.63-2.9.08-6.35-2.66-12.88-2.65a56.57,56.57,0,0,0-10.08,1.55c-.09.8-.12,1.08-.25,1.87a3,3,0,0,1,1.77,1.73c1.78,6.45,3,9.86,8.64,10,6.43-.12,9.37-3.85,10.28-6.45h0c.8-1.87,1.65-2.18,2.64-2.3,1,.12,1.53.43,2.34,2.31h0c.93,2.6,3.92,6.34,10.34,6.47,5.63-.13,7-3.48,8.79-10,.19-.8.86-1.69,1.25-1.71C386.44,101.72,386.4,101.37,386.39,100.59Zm-34.86,11.83c-5.23-.14-6.32-2.89-7.31-7.26-.19-1.19-.28-2,.09-2.39.66-.8,3-1.09,7.32-1.22,3.47-.11,6.64.55,7.95,1.77a1.78,1.78,0,0,1,.63,1.3v.07C360.49,107,357.74,112,351.53,112.42Zm31.54-7.33c-1,4.6-2.76,7.49-7.54,7.25a9.17,9.17,0,0,1-6.76-3.28,5.79,5.79,0,0,1-1.46-4.08v-.07a2.19,2.19,0,0,1,.8-1.54,9.69,9.69,0,0,1,5.56-1.82,14.08,14.08,0,0,1,1.95,0c4.5.25,6.71.56,7.34,1.34C383.27,103.27,383.25,103.88,383.07,105.09Z",
    transform: "translate(-1.65)",
    fill: "#333"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "face-2",
    "data-name": "face"
  }, _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M464.79,230.13c-.39,4.69-2.18,8.16-4,7.76a1.88,1.88,0,0,1-.91-.57,22.45,22.45,0,0,1-3.85,9.19c-4.18,5.85-5,14.68-14.79,14.87-.4,0-2.82,2.12-5.86,2.12-3.65,0-6.32-1.85-6.84-1.92-8.62-1.29-12.17-9.76-15.94-15.07a22.28,22.28,0,0,1-3.83-9.11,1.81,1.81,0,0,1-.23.18,1.56,1.56,0,0,1-.43.21c-1.8.54-3.68-2.79-4.19-7.45s.51-8.87,2.32-9.41c.72-.21,1.45.2,2.11,1.07,1-9.74,3.29-18.4,7.59-24.47a22.31,22.31,0,0,1,36.75,0c4.29,6.05,6.57,14.68,7.58,24.38a2,2,0,0,1,1.93-1C464,221.31,465.17,225.44,464.79,230.13Z",
    transform: "translate(-1.65)",
    fill: "#bb7557"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.05,223.76a1.36,1.36,0,0,0-1.08.47,3.67,3.67,0,0,0-.79,1.41l-.12.45c0,.15-.05.3-.08.46s-.07.62-.1.94a3.7,3.7,0,0,0,0,.47v.47c0,.31,0,.62.05.93a18.37,18.37,0,0,0,.61,3.52,7.71,7.71,0,0,0,.62,1.55,2,2,0,0,0,.21.32,2.26,2.26,0,0,0,.23.29.94.94,0,0,0,.52.32,2.8,2.8,0,0,1-.74-1.21,10.34,10.34,0,0,1-.43-1.55,30.38,30.38,0,0,1-.46-3.37,11.24,11.24,0,0,1,.12-3.29,4.29,4.29,0,0,1,.54-1.35A2.33,2.33,0,0,1,407.05,223.76Z",
    transform: "translate(-1.65)",
    fill: "#f2f2f2",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.57,235.1a1.18,1.18,0,0,0,1.11.1,2.19,2.19,0,0,0,1-.94l.2-.36c.07-.12.11-.26.17-.39a7.69,7.69,0,0,0,.28-.85c0-.14.07-.29.1-.44l.09-.44c.06-.3.08-.61.13-.91a20.29,20.29,0,0,0,.09-3.66,10.45,10.45,0,0,0-.3-1.79c0-.14-.09-.28-.14-.41a2.66,2.66,0,0,0-.16-.39,1.45,1.45,0,0,0-.44-.57,4.05,4.05,0,0,1,.48,1.52,13.6,13.6,0,0,1,.12,1.7,32.72,32.72,0,0,1-.21,3.43,10,10,0,0,1-.73,3.07,2.69,2.69,0,0,1-.78,1A1.49,1.49,0,0,1,460.57,235.1Z",
    transform: "translate(-1.65)",
    fill: "#f2f2f2",
    style: {
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M448.36,216.69a7.79,7.79,0,0,0-2.8-1.23,8.41,8.41,0,0,0-3.62.1c-2.46.61-4.69,1.73-6.95,2.19a14.64,14.64,0,0,1-6.59-.34c-2.15-.51-4.37-1-6.64-1.37,2,.75,4.08,1.45,6.18,2.07a19.08,19.08,0,0,0,3.35.73,12.17,12.17,0,0,0,3.78-.19c2.55-.57,4.77-1.73,7-2.41A9.13,9.13,0,0,1,448.36,216.69Z",
    transform: "translate(-1.65)",
    fill: "#e6e7e7",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.38,213.47a7.3,7.3,0,0,0-2.62-1.45,8.19,8.19,0,0,0-3.58-.16c-2.49.45-4.79,1.42-7.07,1.74a13.83,13.83,0,0,1-6.44-.81c-2.07-.67-4.2-1.3-6.38-1.87,1.92.91,3.85,1.76,5.85,2.55a18.55,18.55,0,0,0,3.21,1,11.38,11.38,0,0,0,3.74.07c2.57-.39,4.88-1.41,7.14-1.95A8.61,8.61,0,0,1,446.38,213.47Z",
    transform: "translate(-1.65)",
    fill: "#e6e7e7",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.33,214.77a6.47,6.47,0,0,0-2.35-1,7.09,7.09,0,0,0-3,.08c-2.06.51-3.92,1.43-5.81,1.82a12.09,12.09,0,0,1-5.49-.3c-1.79-.43-3.64-.82-5.52-1.16,1.69.63,3.39,1.21,5.14,1.74a15.7,15.7,0,0,0,2.78.61,9.91,9.91,0,0,0,3.15-.14c2.13-.47,4-1.44,5.85-2A7.66,7.66,0,0,1,447.33,214.77Z",
    transform: "translate(-1.65)",
    fill: "#e6e7e7",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M455.56,183.35c-.26-.46-.26-.46-1.09-.66-.18-.14-.34-.28-.5-.42l-.4-.39a4.67,4.67,0,0,0-2.66-1.19l-.46-.08c-1.45-.34-2.68-1.46-4.05-1.88a3.09,3.09,0,0,0-.62-.12,15.37,15.37,0,0,1-3.31.26c1.22.58-1.22-2.29-4.05-1.22l-.51,0-.64-.19a5.76,5.76,0,0,0-4.57.3,31.42,31.42,0,0,1-5.88,1.26l-.68.11c-3.21,1.51-8.71.36-9.9,4.64-.16.16-.34.31-.52.47a27.37,27.37,0,0,0-4.14,4.59l-.44.58c-2.26,2.14-4.09,3.29-3.27,6.13-.09.22-.18.44-.26.66-.25.63-.48,1.28-.7,1.93l-.21.65c-.15.45-.31.88-.45,1.31-.08.22-.15.43-.25.64-.79,1.73-2,3.46-1.33,5.41l-.06.58a11.87,11.87,0,0,0,.14,2.91c0,.22.07.43.11.65-.87,3.09-2.09,4.24.45,6.64,0,.19.07.38.1.57a23.64,23.64,0,0,0,1.39,4.7l3.5,8.2s-1.23-7.33-.54-10.95c0-.13.05-.27.07-.4s.16-.45.23-.67.11-.44.18-.66c1.08-1.46,1.08-3.19,1-5.32,0-.17.08-.34.11-.51.27-1.2.55-2.38.84-3.5,0-.14.07-.28.12-.41a5.66,5.66,0,0,0,1.8-5.09c.1-.21.22-.42.34-.63.84-1.51,1.89-3.17,2.31-3.27a5,5,0,0,1,2.34.15l.57.16a6.47,6.47,0,0,0,5.8,2.19l.38.14a25.48,25.48,0,0,0,8.29,2.14A21.16,21.16,0,0,0,440,202.3l.41-.12c2.65-.91,5.09.24,6.37-2.48l.35-.15c1.83-.77,3.21-1.39,3.59-1.57a.9.9,0,0,1,1,.24,2.94,2.94,0,0,1,.26.25c.31.81.63,1.61,1,2.39.08.19.16.39.22.58-.92,2.13,1.53,3.28,2.29,5.12l.27.61a7.34,7.34,0,0,1,1.9,5.72l.18.69a67.6,67.6,0,0,1,1.57,7.71c.34,2.65-.75,9.06-.75,9.06s2.64-6.44,3.6-9.18a30.54,30.54,0,0,0,1.89-6.49c0-.21.08-.43.13-.64,2.66-2.43.22-5.3.6-7.61a6.49,6.49,0,0,0,.33-.64,5.42,5.42,0,0,0,.38-1.16,5.54,5.54,0,0,0,.07-.57,7.24,7.24,0,0,0-.54-4.17c-.08-.19-.16-.38-.25-.57a2.44,2.44,0,0,1-.92-.64,3.11,3.11,0,0,1-.31-.43c-.29-1.26-.35-3-1.39-4.37a5.18,5.18,0,0,0-.44-.51c-1.59-1.29.25-4.73-3.14-5a1.52,1.52,0,0,0-.44-.38.36.36,0,0,0-.45.06c0-.14.07-.28.11-.41l.09-.37c1.63-2.66-2-2.09-2.64-3.24,0,0,.61,0,.42-.27A.84.84,0,0,0,455.56,183.35Z",
    transform: "translate(-1.65)",
    fill: "#97999a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "face-3",
    "data-name": "face"
  }, _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M474.26,113.87c1.07,9.5-.33,17.57-5.51,22.68s-13.84,7.46-24.24,7.58c-10.4-.06-19.22-2.25-24.29-7.43s-6.68-13.14-5.67-22.65c1.17-9.5,4.37-17.67,9.49-23s12.1-8,20.26-8.08c2.07,0,13.6,3,12-2.66a4.28,4.28,0,0,1,.69,5.1c.78-1.3,5.62,5.48,6.18,2.19a1.1,1.1,0,0,0-.79-1.23,1.93,1.93,0,0,1,1.81,1.28c.64,1.74-1,1.8.45,3.28C469.77,96.22,473,104.37,474.26,113.87Z",
    transform: "translate(-1.65)",
    fill: "#f9f0e6"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M470.49,127.64a2.36,2.36,0,0,0-2,.65c-.56-10.36-3.17-19.26-8.16-25.26s-12.11-9.11-19.94-9.35c-7.61-.05-13.54,2.66-16.95,8.73-3.43,5.86-4.57,15.07-4.65,25.8s-.89,20,4.81,25.57c4.07,3.92,2.95,5.63,11.8,9,1.44,1.75,4.48,3.89,6.5,3.91s4.82-2,6.21-3.75c10-5.08,9.25-4.33,14-8.73a18.63,18.63,0,0,0,5.64-10.05,2.63,2.63,0,0,0,1.25.72c2.25.49,4.43-3,4.85-7.75S472.76,128.08,470.49,127.64Z",
    transform: "translate(-1.65)",
    fill: "#fdd7c7"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M468.06,142a1.84,1.84,0,0,0,1.38.14,2.6,2.6,0,0,0,1.25-.92l.24-.36c.08-.12.13-.26.2-.39a5.16,5.16,0,0,0,.33-.85,3.33,3.33,0,0,0,.13-.45l.1-.45c.07-.3.1-.61.15-.92a16.58,16.58,0,0,0,.06-3.73,8.52,8.52,0,0,0-.4-1.83c-.05-.15-.11-.29-.17-.43s-.14-.26-.21-.39a1.85,1.85,0,0,0-.55-.59,3.75,3.75,0,0,1,.61,1.56,11,11,0,0,1,.17,1.73,27.12,27.12,0,0,1-.2,3.49,8.44,8.44,0,0,1-.88,3.1,2.66,2.66,0,0,1-.95,1A2.11,2.11,0,0,1,468.06,142Z",
    transform: "translate(-1.65)",
    fill: "#b99a8b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M432.88,118.57a4.8,4.8,0,0,1,1.95-1.21,4.15,4.15,0,0,1,2.53.08c1.73.6,3.28,1.68,4.87,2.13a7.33,7.33,0,0,0,4.6-.35c1.5-.51,3.05-1,4.63-1.37-1.42.74-2.84,1.43-4.31,2.06a9.87,9.87,0,0,1-2.33.72,6,6,0,0,1-2.64-.17c-1.79-.55-3.34-1.69-4.9-2.35A4.69,4.69,0,0,0,432.88,118.57Z",
    transform: "translate(-1.65)",
    fill: "#e6e7e7",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.26,115.39a4.94,4.94,0,0,1,1.82-1.43,4,4,0,0,1,2.49-.16c1.75.43,3.36,1.38,4.95,1.68a7.08,7.08,0,0,0,4.5-.82c1.44-.66,2.92-1.29,4.44-1.85-1.33.9-2.68,1.74-4.07,2.52a9.79,9.79,0,0,1-2.24,1,5.71,5.71,0,0,1-2.61.08c-1.79-.38-3.41-1.38-5-1.9A4.57,4.57,0,0,0,434.26,115.39Z",
    transform: "translate(-1.65)",
    fill: "#e6e7e7",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.6,116.68a4.09,4.09,0,0,1,1.63-1,3.58,3.58,0,0,1,2.12.06c1.44.5,2.74,1.4,4.06,1.78a6.23,6.23,0,0,0,3.84-.31c1.25-.43,2.54-.82,3.85-1.16-1.18.63-2.36,1.21-3.58,1.73a8.28,8.28,0,0,1-1.94.61,4.93,4.93,0,0,1-2.21-.14,37.81,37.81,0,0,1-4.09-2A3.93,3.93,0,0,0,433.6,116.68Z",
    transform: "translate(-1.65)",
    fill: "#e6e7e7",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.58,148.93a15,15,0,0,1,1.6,2.3,12.07,12.07,0,0,1,1.15,2.65,4.9,4.9,0,0,1-1.6,5.14,6.09,6.09,0,0,0,1.27-2.33,5,5,0,0,0,0-2.71,16,16,0,0,0-1-2.6C455.54,150.54,455.07,149.73,454.58,148.93Z",
    transform: "translate(-1.65)",
    fill: "#e6e7e7",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.14,148.47a12.26,12.26,0,0,0-1.45,2.08,10.4,10.4,0,0,0-1,2.44,5,5,0,0,0,.08,2.79,5.47,5.47,0,0,0,1.41,2.25,6.89,6.89,0,0,1-1.18-2.34,5,5,0,0,1,0-2.58,14,14,0,0,1,.93-2.4C430.27,149.94,430.7,149.2,431.14,148.47Z",
    transform: "translate(-1.65)",
    fill: "#e6e7e7",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,156.66a7.08,7.08,0,0,0,5.14,2.17,10.05,10.05,0,0,0,5.35-1.63,7.64,7.64,0,0,1-5.33,2.15,6.76,6.76,0,0,1-2.91-.69A5.65,5.65,0,0,1,437,156.66Z",
    transform: "translate(-1.65)",
    fill: "#e6e7e7",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M471.5,98.77a20.73,20.73,0,0,0,1.43-6.08c.79-9.56-4.76-18-12.38-19-5.26-.64-10.14,2.48-12.92,7.62a8.32,8.32,0,0,0-3.74-1.46c-5.3-.64-10,4.18-10.65,10.8-7.86,1.9-13.27,5.88-13.26,10.46,0,6.4,23.64,11.51,23.64,11.51a108.24,108.24,0,0,0,14.23-4.32,11.17,11.17,0,0,0,5.24-.68c.37,3.66,2.71,6.63,5.77,7,3.57.43,6.77-2.84,7.14-7.32C476.32,103.42,474.38,99.89,471.5,98.77Z",
    transform: "translate(-1.65)",
    fill: "#f9f0e6"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M447.93,81.81a5.19,5.19,0,0,1,1.91-.72,9.13,9.13,0,0,1,2.09-.09,17.21,17.21,0,0,1,4,.86,29.16,29.16,0,0,1,7.24,3.66,19.86,19.86,0,0,1,3.05,2.66,16.27,16.27,0,0,1,2.33,3.25A24,24,0,0,1,471,98.72,51.13,51.13,0,0,0,467.46,92a19.9,19.9,0,0,0-5.27-5.24A41.82,41.82,0,0,0,455.46,83a19.72,19.72,0,0,0-3.66-1.24A7.26,7.26,0,0,0,447.93,81.81Z",
    transform: "translate(-1.65)",
    fill: "#e6e6e5"
  }))), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M319.66,232.74c.31.42.31.42,1.25.62.21.13.39.26.57.39l.46.37a6,6,0,0,0,3,1.11l.53.07c1.66.33,3.06,1.38,4.63,1.77a4.88,4.88,0,0,0,.7.11,20.79,20.79,0,0,1,3.78-.25c-1.39-.54,1.4,2.15,4.62,1.15l.58,0,.74.18a7.83,7.83,0,0,0,5.22-.28,42.63,42.63,0,0,1,6.71-1.18l.78-.1c3.67-1.41,9.95-.33,11.3-4.35l.6-.43a29.05,29.05,0,0,0,4.73-4.3l.49-.54.24-.19.24-.18c2-.64,3.39-1.66,3.34-3.27,0-.12.07-.24.1-.37a3.21,3.21,0,0,0-.18-1.74l.3-.61c.29-.6.55-1.2.8-1.81.08-.21.16-.41.23-.61.18-.42.36-.83.53-1.24a6.28,6.28,0,0,1,.27-.59c.91-1.62,2.3-3.24,1.53-5.07a5,5,0,0,0,.06-.54,9.31,9.31,0,0,0-.15-2.73c0-.2-.08-.4-.13-.61.93-2.71,2.22-3.83,0-5.81l-.23-.21c-.1-.45-.19-.88-.3-1.29,0-.14-.07-.27-.1-.4.33-1.77.1-2.78-1.55-3.88l-.26-.18c0-1.07.24-2.09-1.12-2.7.54,0,.54.21.82.41-.55-.41-1.64-.61-1.3-1.43,0-.15,0-.29,0-.42,0-.54-.11-1-1.2-1.21,0,.41.82,0,.82.41a21.35,21.35,0,0,1-2.05-1.24,4.15,4.15,0,0,1-.27-.32,44.16,44.16,0,0,0-6.81-6.62c-18.91-14.88-40.78-2.46-44.85,1.58a18.75,18.75,0,0,0-2.19,2.67l-.16.24c-1.57,1-2.39,2.26-2.2,3.93l-.12.25-.12.26-.12.26a5.25,5.25,0,0,0-1.68,4.14c0,.12-.09.25-.14.36-2.1,1.21-2.49,2.38-1.66,3.86a3.66,3.66,0,0,1-.13.44c-.11.33-.22.66-.31,1,0,.11-.07.23-.1.34-.45,1.28-1.54,2.5-1.82,3.77a3.58,3.58,0,0,0-.09.45c-.19,1.68,1,3.42.74,4.9a5.09,5.09,0,0,0-.39.6,4.21,4.21,0,0,0-.42,1.09,5.07,5.07,0,0,0-.09.54,5.66,5.66,0,0,0,.62,3.9c.09.18.19.36.29.54a2.87,2.87,0,0,1,1.05.6,2.64,2.64,0,0,1,.35.4c.33,1.18.4,2.79,1.59,4.09a3.83,3.83,0,0,0,.5.48c1.81,1.2-.28,4.43,3.58,4.67a2,2,0,0,0,.5.36.46.46,0,0,0,.52-.06,3.43,3.43,0,0,0-.12.39c0,.12-.08.24-.11.35-1.86,2.49,2.32,1.95,3,3,0,0-.7,0-.49.25A.85.85,0,0,0,319.66,232.74Z",
    transform: "translate(-1.65)",
    fill: "#97999a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "face-4",
    "data-name": "face"
  }, _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M373.1,207.61c-.38,4.42-2.1,7.69-3.85,7.31a1.75,1.75,0,0,1-.88-.53,20.82,20.82,0,0,1-3.73,8.65c-4,5.52-10.76,12.65-20.21,12.82a18,18,0,0,1-2.66-.2c-8.34-1.21-15.48-7.62-19.12-12.62a20.63,20.63,0,0,1-3.71-8.58,1.18,1.18,0,0,1-.22.17,1.38,1.38,0,0,1-.41.19c-1.74.52-3.56-2.62-4.06-7s.5-8.36,2.24-8.87c.7-.2,1.41.19,2.05,1,1-9.17,3.18-17.33,7.34-23a21.9,21.9,0,0,1,35.54,0c4.14,5.7,6.35,13.82,7.33,23a1.93,1.93,0,0,1,1.86-.94C372.36,199.3,373.47,203.19,373.1,207.61Z",
    transform: "translate(-1.65)",
    fill: "#bb7557"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.27,201.61a1.32,1.32,0,0,0-1,.44,3.3,3.3,0,0,0-.76,1.33l-.12.42c0,.14-.05.29-.08.44a8.46,8.46,0,0,0-.1.88,3.38,3.38,0,0,0,0,.45V206c0,.29,0,.58.05.87a17.07,17.07,0,0,0,.59,3.32,7.43,7.43,0,0,0,.6,1.46l.2.31a3,3,0,0,0,.22.26,1,1,0,0,0,.51.31,2.73,2.73,0,0,1-.72-1.14,11.91,11.91,0,0,1-.42-1.46,29.5,29.5,0,0,1-.44-3.17,10.36,10.36,0,0,1,.12-3.11,3.71,3.71,0,0,1,.53-1.27A2.11,2.11,0,0,1,317.27,201.61Z",
    transform: "translate(-1.65)",
    fill: "#f2f2f2",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369,212.3a1.21,1.21,0,0,0,1.08.09,2.21,2.21,0,0,0,1-.89l.19-.34c.06-.11.11-.25.16-.37a6.67,6.67,0,0,0,.27-.79c0-.13.07-.28.1-.42l.09-.42c.05-.28.08-.57.12-.85a19.84,19.84,0,0,0,.09-3.45,9.33,9.33,0,0,0-.3-1.69,3,3,0,0,0-.13-.39c0-.12-.1-.24-.15-.36a1.59,1.59,0,0,0-.42-.54,3.86,3.86,0,0,1,.45,1.44,12,12,0,0,1,.12,1.59,29.2,29.2,0,0,1-.2,3.24,9,9,0,0,1-.71,2.89,2.69,2.69,0,0,1-.75,1A1.57,1.57,0,0,1,369,212.3Z",
    transform: "translate(-1.65)",
    fill: "#f2f2f2",
    style: {
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M352.86,192.19a4.35,4.35,0,0,0-4.06-.82c-1.56.44-3,1.25-4.4,1.58a8.07,8.07,0,0,1-4.17-.24c-1.37-.37-2.77-.71-4.21-1,1.29.55,2.59,1,3.92,1.5a10,10,0,0,0,2.11.53,6.56,6.56,0,0,0,2.4-.14c1.61-.41,3-1.25,4.42-1.74A5,5,0,0,1,352.86,192.19Z",
    transform: "translate(-1.65)",
    fill: "#e6e7e7",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.6,189.85a4.18,4.18,0,0,0-3.91-1.16c-1.58.33-3,1-4.48,1.26a7.87,7.87,0,0,1-4.08-.59c-1.31-.48-2.65-.94-4-1.35,1.22.66,2.44,1.27,3.71,1.84a9.91,9.91,0,0,0,2,.7,6.21,6.21,0,0,0,2.36.06,45.38,45.38,0,0,0,4.52-1.42A4.92,4.92,0,0,1,351.6,189.85Z",
    transform: "translate(-1.65)",
    fill: "#e6e7e7",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.21,190.79a4.1,4.1,0,0,0-1.49-.75,3.93,3.93,0,0,0-1.92.06c-1.3.37-2.48,1-3.67,1.31a6.73,6.73,0,0,1-3.48-.21c-1.14-.31-2.3-.59-3.49-.84,1.06.46,2.14.88,3.25,1.26a8.1,8.1,0,0,0,1.76.44,5.45,5.45,0,0,0,2-.1c1.34-.34,2.52-1,3.69-1.45A4.3,4.3,0,0,1,352.21,190.79Z",
    transform: "translate(-1.65)",
    fill: "#e6e7e7",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.12,222a14.41,14.41,0,0,0-1.37,2.21,12.3,12.3,0,0,0-1,2.54,5.25,5.25,0,0,0,.07,2.81,4.86,4.86,0,0,0,1.34,2.11,6.2,6.2,0,0,1-1.12-2.22,5.57,5.57,0,0,1,0-2.6,15.86,15.86,0,0,1,.9-2.5C334.3,223.49,334.7,222.72,335.12,222Z",
    transform: "translate(-1.65)",
    fill: "#e6e7e7",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.46,222.2a11.84,11.84,0,0,1,1.27,2,11.17,11.17,0,0,1,.9,2.33,5.26,5.26,0,0,1-.06,2.67,5.34,5.34,0,0,1-1.22,2.18,7,7,0,0,0,1-2.26,5.42,5.42,0,0,0,0-2.47,13.85,13.85,0,0,0-.82-2.29A24,24,0,0,0,353.46,222.2Z",
    transform: "translate(-1.65)",
    fill: "#e6e7e7",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M375.22,192.36a1.06,1.06,0,0,1,0-.5c0-.15.06-.3.08-.45a12.24,12.24,0,0,0,.16-3.13c0-.14,0-.28,0-.42a1,1,0,0,1,0-.42c.55-1.82-.47-3.45-1.31-5.07l-.27-.54c.61-2.49-.65-3.93-2-5.89a4.31,4.31,0,0,0,.12-.67c.25-2.36-1.59-3.57-3.83-5.57a.75.75,0,0,1-.15-.16l-.42-.54a30.94,30.94,0,0,0-4.7-4.94l-.36-.3a1.22,1.22,0,0,1-.33-.48c-.9-2.08-2.79-4.09-5.76-3.56l-.69-.11a25.07,25.07,0,0,1-4-.79l-1.59-.41a25.49,25.49,0,0,1-3.57-.76,7.28,7.28,0,0,0-2.13-.26c-1.3,0-3.39.08-3.59.12l-.16,0a22.7,22.7,0,0,1-3.9.87l-1.63.41c-3.61,1.2-9,.43-10.44,4.45a1.22,1.22,0,0,1-.33.49l-.35.29-.44.37-.43.38c-2.46,1-4,2.15-4.26,4.73a1.07,1.07,0,0,1-.14.16c-1.84,1.64-3.41,2.75-3.78,4.39a3.43,3.43,0,0,0-.08.56,10,10,0,0,0-1.37,5.79l-.12.35c0,.12-.09.23-.13.35s-.17.46-.27.69c-.87,1.8-2.19,3.59-1.59,5.62a1.18,1.18,0,0,1,.05.42c0,.13,0,.27,0,.41a12.31,12.31,0,0,0,.15,3.14c0,.14.06.29.08.44a.94.94,0,0,1,0,.5c-.95,3.05-2.15,4.31.33,6.68a1,1,0,0,1,.31.57,2.56,2.56,0,0,1,.05.27c.37,1.81,1.55-.16,2.23,1.39l2.14,3.78c.71,1.59.64-2.37.64-3.31a1,1,0,0,1,.07-.36c.07-.19.13-.37.19-.56l.15-.54a1.41,1.41,0,0,1,.17-.32c1-1.39,1.1-3,1-4.95,0-.35.09-.93.12-1.28.3-1.25.61-1.89.92-3.06a5.33,5.33,0,0,0,2.78-.27,7.78,7.78,0,0,0,1.94-1.51c.57-.59,1.45.73,2.49.19l.64-.31c2-.75,4.19-1,6-2.11l.54-.12,1.23.08c2.63.9,5.31-.41,7.84-.79,2.53.38,5.21,1.7,7.84.8l1.22-.09c1,.21,5,2.07,6.38,2.51,1.88.58,1.76-5.21,2-5.12,1,2.37.39,5.82,1.9,7.44.1.09,1.08-2.83,1.19-2.75.32.26-.21,3.5.17,3.69,1.21.65,2.75-.46,2.77-.37.32,1.18.62,1.81.92,3.07,0,.35.09.92.12,1.28-.09,1.94,0,2.28,1,3.68a1.2,1.2,0,0,1,.16.32l.15.54c.06.19.12.37.19.56a1,1,0,0,1,.07.35c0,1-.07,4.91.64,3.32l2.14-3.79c.68-1.54,1.86.43,2.23-1.39,0-.08,0-.17.05-.26a1.14,1.14,0,0,1,.31-.58C377.36,196.66,376.16,195.41,375.22,192.36Z",
    transform: "translate(-1.65)",
    fill: "#97999a"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M357.5,202.21c-5,0-9.1,2.58-9.58,5.87a10.66,10.66,0,0,0-7,0c-.48-3.29-4.59-5.87-9.57-5.87-5.31,0-9.62,2.92-9.62,6.51s4.31,6.52,9.62,6.52c5.07,0,9.22-2.67,9.58-6a9,9,0,0,1,6.94,0c.39,3.36,4.54,6,9.59,6,5.3,0,9.62-2.92,9.62-6.52S362.8,202.21,357.5,202.21Zm-26.11,12c-4.56,0-8.27-2.47-8.27-5.51s3.71-5.5,8.27-5.5,8.27,2.47,8.27,5.5S336,214.23,331.39,214.23Zm26.11,0c-4.56,0-8.27-2.47-8.27-5.51s3.71-5.5,8.27-5.5,8.27,2.47,8.27,5.5S362.06,214.23,357.5,214.23Z",
    transform: "translate(-1.65)",
    fill: "#5b5342"
  }))), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M161.34,17.85a10.45,10.45,0,0,1-.77,4.17,7.15,7.15,0,0,1-2.16,2.84l2.85,2.24-2.25,2-3.64-2.93a7.87,7.87,0,0,1-1.3.1,7.13,7.13,0,0,1-3.8-1,6.8,6.8,0,0,1-2.59-2.93,10.07,10.07,0,0,1-.93-4.37V17.1a10.3,10.3,0,0,1,.92-4.46,6.75,6.75,0,0,1,2.57-3,7.54,7.54,0,0,1,7.61,0,6.83,6.83,0,0,1,2.58,3,10.27,10.27,0,0,1,.91,4.44Zm-3.57-.78a7.22,7.22,0,0,0-1-4.09,3.41,3.41,0,0,0-5.49,0,7.07,7.07,0,0,0-1,4.05v.84a7.31,7.31,0,0,0,1,4.07,3.16,3.16,0,0,0,2.78,1.45A3.1,3.1,0,0,0,156.8,22a7.22,7.22,0,0,0,1-4.06Z",
    transform: "translate(-1.65)",
    fill: "#fff"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M171.33,24.73a4.26,4.26,0,0,1-3.48,1.53,4,4,0,0,1-3.12-1.17,5,5,0,0,1-1.1-3.45V13.3H167v8.23c0,1.33.6,2,1.81,2a2.45,2.45,0,0,0,2.37-1.2v-9h3.42V26h-3.2Z",
    transform: "translate(-1.65)",
    fill: "#fff"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M183.05,26.26a6.22,6.22,0,0,1-4.56-1.72A6.1,6.1,0,0,1,176.73,20v-.33a7.75,7.75,0,0,1,.74-3.43,5.47,5.47,0,0,1,2.1-2.33,5.86,5.86,0,0,1,3.1-.82,5.28,5.28,0,0,1,4.12,1.65,6.69,6.69,0,0,1,1.5,4.67v1.39h-8.11a3.17,3.17,0,0,0,1,2,3,3,0,0,0,2.1.75,3.65,3.65,0,0,0,3.07-1.42L188,24a5.14,5.14,0,0,1-2.08,1.69A6.83,6.83,0,0,1,183.05,26.26Zm-.39-10.46a2.12,2.12,0,0,0-1.64.69,3.54,3.54,0,0,0-.81,2h4.73v-.27a2.53,2.53,0,0,0-.61-1.76A2.2,2.2,0,0,0,182.66,15.8Z",
    transform: "translate(-1.65)",
    fill: "#fff"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M197.11,22.51a1.09,1.09,0,0,0-.62-1,7,7,0,0,0-2-.65C191.48,20.25,190,19,190,17a3.5,3.5,0,0,1,1.4-2.83,5.68,5.68,0,0,1,3.68-1.14,6.11,6.11,0,0,1,3.88,1.14,3.59,3.59,0,0,1,1.45,3H197a1.67,1.67,0,0,0-.47-1.21,2,2,0,0,0-1.47-.48,2,2,0,0,0-1.33.39,1.24,1.24,0,0,0-.47,1,1,1,0,0,0,.53.91,5.61,5.61,0,0,0,1.81.6,15,15,0,0,1,2.14.57q2.7,1,2.7,3.43a3.32,3.32,0,0,1-1.5,2.82,6.48,6.48,0,0,1-3.86,1.07,6.76,6.76,0,0,1-2.84-.57,4.77,4.77,0,0,1-1.95-1.56,3.65,3.65,0,0,1-.7-2.15h3.22a1.8,1.8,0,0,0,.67,1.39,2.69,2.69,0,0,0,1.67.48,2.45,2.45,0,0,0,1.48-.37A1.16,1.16,0,0,0,197.11,22.51Z",
    transform: "translate(-1.65)",
    fill: "#fff"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M206.68,10.17V13.3h2.17v2.49h-2.17v6.35a1.56,1.56,0,0,0,.27,1,1.36,1.36,0,0,0,1,.3,5.87,5.87,0,0,0,1-.08V26a7.08,7.08,0,0,1-2.06.3c-2.38,0-3.6-1.2-3.64-3.61V15.79h-1.86V13.3h1.86V10.17Z",
    transform: "translate(-1.65)",
    fill: "#fff"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M210.72,10a1.68,1.68,0,0,1,.51-1.26,2.23,2.23,0,0,1,2.79,0,1.69,1.69,0,0,1,.52,1.26,1.67,1.67,0,0,1-.53,1.27,2.15,2.15,0,0,1-2.76,0A1.67,1.67,0,0,1,210.72,10Zm3.62,16h-3.42V13.3h3.42Z",
    transform: "translate(-1.65)",
    fill: "#fff"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M216.61,19.54a7.49,7.49,0,0,1,.73-3.37,5.26,5.26,0,0,1,2.1-2.3,6.11,6.11,0,0,1,3.18-.81,5.77,5.77,0,0,1,4.2,1.58,6.29,6.29,0,0,1,1.82,4.28l0,.87a6.66,6.66,0,0,1-1.64,4.7,6.34,6.34,0,0,1-8.78,0,6.76,6.76,0,0,1-1.64-4.8Zm3.4.24a4.74,4.74,0,0,0,.68,2.78,2.45,2.45,0,0,0,3.88,0,5.2,5.2,0,0,0,.7-3,4.73,4.73,0,0,0-.7-2.76,2.42,2.42,0,0,0-3.88,0A5.28,5.28,0,0,0,220,19.78Z",
    transform: "translate(-1.65)",
    fill: "#fff"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M233.89,13.3l.11,1.47a4.41,4.41,0,0,1,3.65-1.71,3.72,3.72,0,0,1,3,1.19,5.56,5.56,0,0,1,1,3.55V26h-3.4V17.88a2.23,2.23,0,0,0-.47-1.57,2.15,2.15,0,0,0-1.57-.48,2.33,2.33,0,0,0-2.15,1.22v9h-3.4V13.3Z",
    transform: "translate(-1.65)",
    fill: "#fff"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M251.15,22.51a1.09,1.09,0,0,0-.62-1,7,7,0,0,0-2-.65C245.52,20.25,244,19,244,17a3.5,3.5,0,0,1,1.4-2.83,5.68,5.68,0,0,1,3.68-1.14A6.11,6.11,0,0,1,253,14.2a3.59,3.59,0,0,1,1.45,3H251a1.67,1.67,0,0,0-.47-1.21,2,2,0,0,0-1.47-.48,2,2,0,0,0-1.33.39,1.24,1.24,0,0,0-.47,1,1,1,0,0,0,.53.91,5.61,5.61,0,0,0,1.81.6,15,15,0,0,1,2.14.57q2.7,1,2.7,3.43a3.32,3.32,0,0,1-1.5,2.82,6.48,6.48,0,0,1-3.86,1.07,6.76,6.76,0,0,1-2.84-.57,4.77,4.77,0,0,1-1.95-1.56,3.65,3.65,0,0,1-.7-2.15h3.22a1.8,1.8,0,0,0,.67,1.39,2.69,2.69,0,0,0,1.67.48,2.45,2.45,0,0,0,1.48-.37A1.16,1.16,0,0,0,251.15,22.51Z",
    transform: "translate(-1.65)",
    fill: "#fff"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M257.53,30.32l-1.78-.93.42-.76a6,6,0,0,0,.81-2.86V23.13h2.88l0,2.36a6,6,0,0,1-.65,2.63A6.9,6.9,0,0,1,257.53,30.32Z",
    transform: "translate(-1.65)",
    fill: "#fff"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M271.66,13.3l.1,1.47a4.44,4.44,0,0,1,3.66-1.71,3.68,3.68,0,0,1,3,1.19,5.56,5.56,0,0,1,1,3.55V26h-3.4V17.88a2.19,2.19,0,0,0-.48-1.57,2.11,2.11,0,0,0-1.56-.48,2.32,2.32,0,0,0-2.15,1.22v9h-3.4V13.3Z",
    transform: "translate(-1.65)",
    fill: "#fff"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M289.65,24.73a4.27,4.27,0,0,1-3.49,1.53A4,4,0,0,1,283,25.09a5.06,5.06,0,0,1-1.1-3.45V13.3h3.4v8.23c0,1.33.6,2,1.81,2a2.45,2.45,0,0,0,2.38-1.2v-9h3.41V26h-3.2Z",
    transform: "translate(-1.65)",
    fill: "#fff"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M295,19.57a7.64,7.64,0,0,1,1.33-4.74A4.33,4.33,0,0,1,300,13.06,3.9,3.9,0,0,1,303,14.45V8h3.41V26h-3.07l-.17-1.36a4,4,0,0,1-3.27,1.59,4.3,4.3,0,0,1-3.6-1.77A7.88,7.88,0,0,1,295,19.57Zm3.4.25a5,5,0,0,0,.62,2.75,2,2,0,0,0,1.81.95A2.29,2.29,0,0,0,303,22.19v-5a2.25,2.25,0,0,0-2.2-1.33Q298.38,15.83,298.38,19.82Z",
    transform: "translate(-1.65)",
    fill: "#fff"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M308.59,19.57A7.44,7.44,0,0,1,310,14.85a4.54,4.54,0,0,1,3.76-1.79A3.94,3.94,0,0,1,317,14.5l.14-1.2h3.09V25.6a5.48,5.48,0,0,1-.76,2.91,4.9,4.9,0,0,1-2.14,1.88,7.52,7.52,0,0,1-3.22.65,7,7,0,0,1-2.73-.56,4.74,4.74,0,0,1-2-1.44l1.5-2.07A4,4,0,0,0,314,28.39a2.92,2.92,0,0,0,2.11-.72,2.73,2.73,0,0,0,.75-2.06v-.68a3.9,3.9,0,0,1-3.09,1.33A4.51,4.51,0,0,1,310,24.47a7.43,7.43,0,0,1-1.42-4.76Zm3.4.25a4.68,4.68,0,0,0,.69,2.72,2.23,2.23,0,0,0,1.91,1,2.34,2.34,0,0,0,2.22-1.17V17a2.33,2.33,0,0,0-2.2-1.16,2.22,2.22,0,0,0-1.92,1A5.2,5.2,0,0,0,312,19.82Z",
    transform: "translate(-1.65)",
    fill: "#fff"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M328.7,26.26a6.22,6.22,0,0,1-4.56-1.72A6.1,6.1,0,0,1,322.38,20v-.33a7.75,7.75,0,0,1,.74-3.43,5.35,5.35,0,0,1,2.1-2.33,5.86,5.86,0,0,1,3.1-.82,5.28,5.28,0,0,1,4.11,1.65,6.69,6.69,0,0,1,1.5,4.67v1.39h-8.1a3.17,3.17,0,0,0,1,2,3,3,0,0,0,2.1.75A3.67,3.67,0,0,0,332,22.1L333.66,24a5.17,5.17,0,0,1-2.07,1.69A6.83,6.83,0,0,1,328.7,26.26Zm-.39-10.46a2.11,2.11,0,0,0-1.64.69,3.54,3.54,0,0,0-.81,2h4.73v-.27a2.53,2.53,0,0,0-.61-1.76A2.2,2.2,0,0,0,328.31,15.8Z",
    transform: "translate(-1.65)",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 162.44,
    y: 299.3,
    width: 152.15,
    height: 34.93,
    fill: "#ef5182"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M178.59,325.33V308.2h5.27a8,8,0,0,1,4,1,7.15,7.15,0,0,1,2.79,2.9,9,9,0,0,1,1,4.26v.79a8.92,8.92,0,0,1-1,4.25,7,7,0,0,1-2.77,2.88,8.08,8.08,0,0,1-4,1Zm3.53-14.28v11.44h1.71a3.83,3.83,0,0,0,3.16-1.35,6.13,6.13,0,0,0,1.12-3.87v-.91a6.23,6.23,0,0,0-1.08-4,3.84,3.84,0,0,0-3.17-1.35Z",
    transform: "translate(-1.65)",
    fill: "#fff"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M201.4,325.33a4,4,0,0,1-.34-1.15,4.1,4.1,0,0,1-3.21,1.38,4.52,4.52,0,0,1-3.1-1.08,3.48,3.48,0,0,1-1.23-2.73,3.61,3.61,0,0,1,1.5-3.11,7.45,7.45,0,0,1,4.34-1.09h1.56v-.73a2.09,2.09,0,0,0-.45-1.41,1.76,1.76,0,0,0-1.43-.53,2.07,2.07,0,0,0-1.35.41,1.41,1.41,0,0,0-.49,1.13h-3.4a3.4,3.4,0,0,1,.69-2.05,4.43,4.43,0,0,1,1.93-1.47,7,7,0,0,1,2.8-.54,5.54,5.54,0,0,1,3.73,1.18,4.15,4.15,0,0,1,1.38,3.33v5.51a6.14,6.14,0,0,0,.51,2.75v.2ZM198.59,323a3,3,0,0,0,1.39-.33,2.27,2.27,0,0,0,.94-.9v-2.19h-1.27c-1.7,0-2.61.59-2.72,1.76v.2a1.36,1.36,0,0,0,.45,1.05A1.75,1.75,0,0,0,198.59,323Z",
    transform: "translate(-1.65)",
    fill: "#fff"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M211,309.47v3.13h2.17v2.49H211v6.35a1.56,1.56,0,0,0,.27,1,1.36,1.36,0,0,0,1,.3,5.87,5.87,0,0,0,1-.08v2.58a7.08,7.08,0,0,1-2.06.3c-2.38,0-3.6-1.2-3.64-3.61v-6.86h-1.86V312.6h1.86v-3.13Z",
    transform: "translate(-1.65)",
    fill: "#fff"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M222.47,325.33a3.72,3.72,0,0,1-.35-1.15,4.1,4.1,0,0,1-3.21,1.38,4.52,4.52,0,0,1-3.1-1.08,3.48,3.48,0,0,1-1.23-2.73,3.61,3.61,0,0,1,1.5-3.11,7.45,7.45,0,0,1,4.34-1.09H222v-.73a2.09,2.09,0,0,0-.45-1.41,1.76,1.76,0,0,0-1.43-.53,2.07,2.07,0,0,0-1.35.41,1.4,1.4,0,0,0-.48,1.13h-3.41a3.4,3.4,0,0,1,.69-2.05,4.48,4.48,0,0,1,1.93-1.47,7,7,0,0,1,2.8-.54,5.53,5.53,0,0,1,3.73,1.18,4.16,4.16,0,0,1,1.39,3.33v5.51a6,6,0,0,0,.5,2.75v.2ZM219.65,323a3,3,0,0,0,1.39-.33,2.22,2.22,0,0,0,.94-.9v-2.19h-1.27c-1.7,0-2.61.59-2.72,1.76v.2a1.36,1.36,0,0,0,.45,1.05A1.76,1.76,0,0,0,219.65,323Z",
    transform: "translate(-1.65)",
    fill: "#fff"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M228.89,329.62l-1.78-.93.43-.76a6.24,6.24,0,0,0,.81-2.86v-2.64h2.87v2.36a6.16,6.16,0,0,1-.66,2.63A6.76,6.76,0,0,1,228.89,329.62Z",
    transform: "translate(-1.65)",
    fill: "#fff"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M243.48,325.33h-3.41V307.25h3.41Z",
    transform: "translate(-1.65)",
    fill: "#fff"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M253.66,325.33a4,4,0,0,1-.35-1.15,4.1,4.1,0,0,1-3.21,1.38,4.54,4.54,0,0,1-3.1-1.08,3.48,3.48,0,0,1-1.23-2.73,3.61,3.61,0,0,1,1.5-3.11,7.45,7.45,0,0,1,4.34-1.09h1.56v-.73a2.09,2.09,0,0,0-.45-1.41,1.76,1.76,0,0,0-1.43-.53,2.07,2.07,0,0,0-1.35.41,1.4,1.4,0,0,0-.48,1.13h-3.4a3.39,3.39,0,0,1,.68-2.05,4.48,4.48,0,0,1,1.93-1.47,7,7,0,0,1,2.8-.54,5.53,5.53,0,0,1,3.73,1.18,4.16,4.16,0,0,1,1.39,3.33v5.51a6,6,0,0,0,.5,2.75v.2ZM250.84,323a2.94,2.94,0,0,0,1.39-.33,2.22,2.22,0,0,0,.94-.9v-2.19H251.9c-1.7,0-2.61.59-2.72,1.76v.2a1.36,1.36,0,0,0,.45,1.05A1.76,1.76,0,0,0,250.84,323Z",
    transform: "translate(-1.65)",
    fill: "#fff"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M270.67,319.08a7.71,7.71,0,0,1-1.31,4.77,4.31,4.31,0,0,1-3.64,1.71,4,4,0,0,1-3.31-1.59l-.15,1.36H259.2V307.25h3.4v6.49a3.85,3.85,0,0,1,3.09-1.38,4.36,4.36,0,0,1,3.65,1.71,7.68,7.68,0,0,1,1.33,4.82Zm-3.4-.25a5.18,5.18,0,0,0-.61-2.82,2.08,2.08,0,0,0-1.83-.88,2.23,2.23,0,0,0-2.23,1.33v5a2.27,2.27,0,0,0,2.26,1.34A2.1,2.1,0,0,0,267,321.2,8.21,8.21,0,0,0,267.27,318.83Z",
    transform: "translate(-1.65)",
    fill: "#fff"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M278.62,325.56a6.26,6.26,0,0,1-4.56-1.72,6.1,6.1,0,0,1-1.76-4.57v-.33a7.62,7.62,0,0,1,.75-3.43,5.35,5.35,0,0,1,2.1-2.33,5.81,5.81,0,0,1,3.1-.82,5.28,5.28,0,0,1,4.11,1.65,6.69,6.69,0,0,1,1.5,4.67v1.39h-8.11a3.13,3.13,0,0,0,1,2,3,3,0,0,0,2.1.75,3.67,3.67,0,0,0,3.07-1.42l1.67,1.87a5.17,5.17,0,0,1-2.07,1.69A6.87,6.87,0,0,1,278.62,325.56Zm-.39-10.46a2.12,2.12,0,0,0-1.64.69,3.47,3.47,0,0,0-.8,2h4.73v-.27a2.54,2.54,0,0,0-.62-1.76A2.19,2.19,0,0,0,278.23,315.1Z",
    transform: "translate(-1.65)",
    fill: "#fff"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M289.38,325.33H286V307.25h3.42Z",
    transform: "translate(-1.65)",
    fill: "#fff"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M299.07,321.81a1.08,1.08,0,0,0-.62-1,7,7,0,0,0-2-.65c-3-.63-4.54-1.92-4.54-3.85a3.49,3.49,0,0,1,1.41-2.83,5.63,5.63,0,0,1,3.67-1.14,6.11,6.11,0,0,1,3.88,1.14,3.59,3.59,0,0,1,1.45,3h-3.4a1.67,1.67,0,0,0-.47-1.21,2,2,0,0,0-1.47-.48,2,2,0,0,0-1.33.39,1.24,1.24,0,0,0-.47,1,1,1,0,0,0,.54.91,5.44,5.44,0,0,0,1.8.6,15,15,0,0,1,2.14.57q2.7,1,2.7,3.43a3.3,3.3,0,0,1-1.5,2.81,6.41,6.41,0,0,1-3.86,1.08,6.76,6.76,0,0,1-2.84-.57,4.9,4.9,0,0,1-1.95-1.56,3.65,3.65,0,0,1-.7-2.15h3.22a1.8,1.8,0,0,0,.67,1.39,2.69,2.69,0,0,0,1.67.48,2.43,2.43,0,0,0,1.48-.37A1.16,1.16,0,0,0,299.07,321.81Z",
    transform: "translate(-1.65)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebFigureMotiv3);
export default __webpack_public_path__ + "static/media/web-figure-motiv-3.946aa1180d050062e30771e3f1908dae.svg";
export { ForwardRef as ReactComponent };